/**
 * [Ref] - Denotes Pseudo Code Reference  
 *  
 * This component is the Order Approval page component. The component displays the Order Approval page details.
 * 
 * App Name: SDI-Walmart
 * Author: Chandrasekar
 * Created Date: 08/18/2020 
 */
import React, { Component } from 'react';
import * as CookieService from '../CookieService';
import * as OrderApprovalAction from '../actions/OrderApprovalAction';
import * as MenuAction from '../actions/MenuAction';
import OrderApprovalStore from '../stores/OrderApprovalStore';
import SDIConstants from '../SDIConstants';
import ReactPaginate from 'react-paginate';
import * as $ from 'jquery';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import MultiSelect from "react-multi-select-component";
import { withTranslation, Trans } from 'react-i18next'
import Select from 'react-select';
import swal from 'sweetalert';
import * as OrderStatusAction from '../actions/OrderStatusAction';
import OrderStatusStore from '../stores/OrderStatusStore';
import { textAlign } from '@material-ui/system';
import { RotatingLines } from 'react-loader-spinner';
let searchTxt = "";
let currentPagePath;
let isPostBack = true;
let isFromEmail = false;
let flagValues;
let SingleaprdecDetails;
let SingleaprdecType;
let SingleaprdecIndex;
let SingleaprdecEvent;
const urlParams = new URLSearchParams(window.location.search);
const QS_fer = urlParams.get('fer');
const QS_op = urlParams.get('op');
const QS_xyz = urlParams.get('xyz');
const QS_HOME = urlParams.get('HOME');
const QS_TYPE = urlParams.get('TYPE');
const QS_FROM = urlParams.get('FROM');
if (QS_fer || QS_op || QS_xyz) {
    isFromEmail = true;
}
let IsBelowMyChain = false
let MultipleorderApprove = false
let NextAprName = ""
let NextAprEmail = ""
let AccordianClick = false;

class OrderApprovalComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            pageNo: 1,
            itemCount: 10,
            pageCount: 0,
            searchText: "",
            searchColumn: "ALL",
            sortColumn: "ORDER_NO",
            sortValue: "ASC",
            startDate: "",
            endDate: "",
            isSearch: false,
            selectedMultiSites: [],
            OrderApprovalData: [],
            LineItemData: [],
            MultisiteDD: [],
            FlagData: {},
            totalCount: 0,
            isMultiSiteDropdownChange: false,
            filterDisplayName: "All",
            isMultipleApproval: false,
            strAppType: "",
            startDateObj: null,
            endDateObj: null,
            isFilterOpen: false,
            isExpanded: false,
            pnlBUVisible: false,
            isPageLoadedOnce: false,
            isFavorited: false,
            ApproverNameDD: [],
            ApproverName: "",
            EnteredByNameDD: [],
            EnteredBy: "", Name: "", Address: "", State: {}, City: "", PostCode: "", ErrName: false, ErrAddress: false, ErrCity: false, ErrState: false, ErrPostCode: false, updateAddr: false, StateDD: [],
            OrderHeaderArray: [],
            OrderLineArray: [],
            FlagArray: [],
            MultipleLineDetails: false,
            MultipleApprDecType: 0,
            SingleLineDetails: false,
            LocationArray: [],
            CountryCode: "",
            valid: false, ExceededData: [],
            ResponseDetails: {
                ResponseSuccessOrders: [],
                ResponseType: "",
                ResponseSuccessMessage: "",
                FailedTechOrders: [],
                FailedDataOrders: [],
                FailedTechMessage: "",
                FailedDataMessage: ""
            },
            inValidComments: false,
            orderDetails: [],
            orderIndex: "",
            isMultiOrderClick: false,
            comments: "",
            showPrice: false
        };
        this.assignApprovals = this.assignApprovals.bind(this);
        this.onAccordianClick = this.onAccordianClick.bind(this);
        this.handleQuantityChange = this.handleQuantityChange.bind(this);
        this.filterClick = this.filterClick.bind(this);
        this.handleSearch = this.handleSearch.bind(this);
        this.handleSearchTxt = this.handleSearchTxt.bind(this);
        this.keyPress = this.keyPress.bind(this);
        this.approveDeclineResponse = this.approveDeclineResponse.bind(this);
        this.approveDeclineSingleOrder = this.approveDeclineSingleOrder.bind(this);
        this.approveDeclineMultipleOrder = this.approveDeclineMultipleOrder.bind(this);
        this.handleDatePicker = this.handleDatePicker.bind(this);
        this.applyFilterclick = this.applyFilterclick.bind(this);
        this.cancelFilter = this.cancelFilter.bind(this);
        this.expandAll = this.expandAll.bind(this);
        this.exportToExcel = this.exportToExcel.bind(this);
        this.deleteItems = this.deleteItems.bind(this);
        this.handleMultiSiteDD = this.handleMultiSiteDD.bind(this);
        this.sortingClick = this.sortingClick.bind(this);
        this.loadFavPageResponse = this.loadFavPageResponse.bind(this);
        this.handleFavorite = this.handleFavorite.bind(this);
        this.filtertoggle = this.filtertoggle.bind(this);
    };
    componentDidMount() {
        CookieService.updateLocalStorageValues("Session_PageName", window.location.pathname);

        currentPagePath = this.props.location.pathname;
        currentPagePath = currentPagePath.indexOf("?") >= 0 ? currentPagePath.split("?")[0] : currentPagePath;
        let getFavPageBO = {
            Session_USERID: CookieService.getLocalStorageValues("Session_UserID"),
            pageURL: currentPagePath.toLowerCase(),
            Session_BUSUNIT: CookieService.getLocalStorageValues("Session_BUSUNIT")
        };
        OrderApprovalAction.getCurrentFavPage(getFavPageBO);
        isPostBack = true;
        this.pageload(this.state.pageNo, this.state.itemCount,
            this.state.searchColumn, this.state.searchText, this.state.sortColumn,
            this.state.sortValue, this.state.startDate, this.state.endDate, this.state.selectedMultiSites, this.state.isMultiSiteDropdownChange);
        OrderApprovalStore.on("approvalData", this.OrderHeaderResponse);
        OrderApprovalStore.on("LineDataResponse", this.BuildLineResponse);
        OrderApprovalStore.on("approveDeclineResponse", this.approveDeclineResponse);
        OrderApprovalStore.on('OrderApproveResponse', this.OrderApproveResponse);
        OrderApprovalStore.on('favpage', this.loadFavPageResponse);
        OrderApprovalStore.on('updateFavPage', this.updateFavPageResponse);
        OrderApprovalStore.on('SaveAddr', this.AddrSaveButtonClickResponse);
        OrderStatusStore.on('PassThroughAuthe', this.IncidentClickResponse);

    };
    componentWillUnmount() {
        OrderApprovalStore.removeListener("approvalData", this.OrderHeaderResponse);
        OrderApprovalStore.on("LineDataResponse", this.BuildLineResponse);
        OrderApprovalStore.removeListener("approveDeclineResponse", this.approveDeclineResponse);
        OrderApprovalStore.removeListener('favpage', this.loadFavPageResponse);
        OrderApprovalStore.removeListener('SaveAddr', this.updateFavPageResponse);
        OrderStatusStore.removeListener('PassThroughAuthe', this.IncidentClickResponse);
        IsBelowMyChain = false;

    }
    pageload = (pageNo, itemCount, searchColumn, searchText, sortColumn, sortValue, startDate, endDate, Multise, isMultiSiteDropdownChange) => {

        let pageLoadBO = {
            QS_fer: QS_fer ? QS_fer : "",
            QS_op: QS_op ? QS_op : "",
            QS_xyz: QS_xyz ? QS_xyz : "",
            QS_HOME: QS_HOME ? QS_HOME : "",
            Session_BUSUNIT: CookieService.getLocalStorageValues("Session_BUSUNIT") ? CookieService.getLocalStorageValues("Session_BUSUNIT") : "",
            Session_USERID: CookieService.getLocalStorageValues("Session_UserID") ? CookieService.getLocalStorageValues("Session_UserID") : "",
            Session_AGENTUSERBU: CookieService.getLocalStorageValues("Session_AGENTUSERBU") ? CookieService.getLocalStorageValues("Session_AGENTUSERBU") : "",
            Session_AGENTUSERID: CookieService.getLocalStorageValues("Session_AGENTUSERID") ? CookieService.getLocalStorageValues("Session_AGENTUSERID") : "",
            isMultiSiteDropdownChange: isMultiSiteDropdownChange,
            Session_USERNAME: CookieService.getLocalStorageValues("Session_USERNAME") ? CookieService.getLocalStorageValues("Session_USERNAME") : "",
            Session_PunchinEnd: "",
            Session_SDIEMP: CookieService.getLocalStorageValues("Session_SDIEMP") ? CookieService.getLocalStorageValues("Session_SDIEMP") : "",
            Session_SITEBU: CookieService.getLocalStorageValues("Session_SITEBU") ? CookieService.getLocalStorageValues("Session_SITEBU") : "",
            Session_CONAME: CookieService.getLocalStorageValues("Session_CONAME") ? CookieService.getLocalStorageValues("Session_CONAME") : "",
            QS_TYPE: QS_TYPE ? QS_TYPE : "",
            QS_FROM: QS_FROM ? QS_FROM : "",
            Session_MULTISITEUSER: CookieService.getLocalStorageValues("Session_MULTISITEUSER") ? CookieService.getLocalStorageValues("Session_MULTISITEUSER") : "",
            Session_ITEMMODE: CookieService.getLocalStorageValues("Session_ITEMMODE") ? CookieService.getLocalStorageValues("Session_ITEMMODE") : "",
            Session_SITEPREFIX: CookieService.getLocalStorageValues("Session_SITEPREFIX") ? CookieService.getLocalStorageValues("Session_SITEPREFIX") : "",
            Session_NSTKONLY: CookieService.getLocalStorageValues("Session_NSTKONLY") ? CookieService.getLocalStorageValues("Session_NSTKONLY") : "",
            Multise: Multise,
            pageNo: pageNo,
            itemCount: itemCount,
            searchColumn: searchColumn,
            searchText: searchText,
            sortColumn: sortColumn,
            sortValue: sortValue,
            startDate: startDate,
            endDate: endDate,
            User_Type: CookieService.getLocalStorageValues("Session_USERTYPE") ? CookieService.getLocalStorageValues("Session_USERTYPE") : "",
            IsWeb: true,
            IsBelowMyChain: IsBelowMyChain
        };
        this.setState({ searchColumn: searchColumn, searchText: searchText, sortValue: sortValue, startDate: startDate, endDate: endDate, pageNo: pageNo })
        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        if (isFromEmail) {
            window.document.title = "Need Approve";
            OrderApprovalAction.getApprovalsUnauth(pageLoadBO);
        } else {
            OrderApprovalAction.getApprovals(pageLoadBO);
        }

    };

    exportToExcel = () => {
        let exportBO = {
            QS_fer: QS_fer ? QS_fer : "",
            Session_NeedApprBUSUNIT: CookieService.getLocalStorageValues("Session_NeedApprBUSUNIT"),
            pnlBUVisible: this.state.pnlBUVisible,
            Session_BUSUNIT: CookieService.getLocalStorageValues("Session_BUSUNIT"),
            Session_USERID: CookieService.getLocalStorageValues("Session_UserID"),
            Session_AGENTUSERBU: CookieService.getLocalStorageValues("Session_AGENTUSERBU"),
            Session_AGENTUSERID: CookieService.getLocalStorageValues("Session_AGENTUSERID"),
            startDate: this.state.startDate,
            endDate: this.state.endDate,
            sortColumn: this.state.sortColumn,
            sortValue: this.state.sortValue,
            searchColumn: this.state.searchColumn,
            searchText: searchTxt,
            User_Type: CookieService.getLocalStorageValues("Session_USERTYPE") ? CookieService.getLocalStorageValues("Session_USERTYPE") : "",
            IsBelowMyChain: IsBelowMyChain,
            showPrice: this.state.showPrice
        };
        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        OrderApprovalAction.exportApprovals(exportBO);
    }
    OrderApproveResponse = () => {
        
        $(`#${SDIConstants.SDILoader}`).addClass('hide');
        let OrderApproveResponse = JSON.parse(OrderApprovalStore.OrderApproveResponse);
        let ApprDt = OrderApproveResponse.ApprDT;
        let StatusDt = OrderApproveResponse.StatusDT;
        let ResponseDet = {
            ResponseSuccessOrders: [],
            ResponseType: "",
            ResponseSuccessMessage: "",
            FailedTechOrders: [],
            FailedDataOrders: [],
            FailedTechMessage: "",
            FailedDataMessage: ""
        }
        ResponseDet.ResponseType = "Approve";
        if (MultipleorderApprove) {
            let SuccessOrders = StatusDt.filter((x) => x.Status == "True" && x.IsExceeded == "False");
            let FailedOrders = StatusDt.filter((x) => x.Status == "False");
            let ExceedData=[];
            if (ApprDt.length > 0) {
                ExceedData = ApprDt.filter((x) => x.IsExceeded == "True");
            }
            if (SuccessOrders.length > 0) {
                let ResponseMsg = ""
                this.pageload(1, this.state.itemCount,
                    this.state.searchColumn, this.state.searchText, this.state.sortColumn,
                    this.state.sortValue, this.state.startDate, this.state.endDate, this.state.selectedMultiSites, this.state.isMultiSiteDropdownChange);
                if (SuccessOrders.length == 1) {
                    ResponseMsg = "The below order has been approved ";
                }
                else {
                    ResponseMsg = "The below orders are approved ";
                }
                ResponseDet.ResponseSuccessOrders = SuccessOrders;
                ResponseDet.ResponseSuccessMessage = ResponseMsg;
            }
            if (FailedOrders.length > 0) {
                let FailTechMsg = "", FailDataMsg = "", locFailTechOrd = "", locFailDataOrd = "", ResponseMsg = ""
                locFailDataOrd = FailedOrders.filter((x) => x.IssueType == "Data");
                locFailTechOrd = FailedOrders.filter((x) => x.IssueType == "Excep");
                if (locFailDataOrd.length > 0) {
                    if (locFailDataOrd.length == 1) {
                        FailDataMsg = "Problem in approving the below order due to "
                    }
                    else {
                        FailDataMsg = "Problem in approving the below orders due to "
                    }
                    ResponseDet.FailedDataOrders = locFailDataOrd;
                    ResponseDet.FailedDataMessage = FailDataMsg;
                }
                if (locFailTechOrd.length > 0) {
                    if (locFailTechOrd.length == 1) {
                        FailTechMsg = "Problem in approving the below order due to "
                    }
                    else {
                        FailTechMsg = "Problem in approving the below orders due to "
                    }
                    ResponseDet.FailedTechOrders = locFailTechOrd;
                    ResponseDet.FailedTechMessage = FailTechMsg;
                }
            }
            this.setState({ ExceededData: ExceedData, ResponseDetails: ResponseDet });
            if ((ResponseDet.ResponseSuccessOrders.length > 0) || (ResponseDet.FailedTechOrders.length > 0) || (ResponseDet.FailedDataOrders.length > 0)) {
                $('#SuccessPopUp').modal('show');
            }
            else {
                if (ExceedData.length > 0) {
                    $('#Exceeded-Popup').modal('show');
                }
            }
        }
        else {
            if (StatusDt[0].Status == "True") {
                this.pageload(1, this.state.itemCount,
                    this.state.searchColumn, this.state.searchText, this.state.sortColumn,
                    this.state.sortValue, this.state.startDate, this.state.endDate, this.state.selectedMultiSites, this.state.isMultiSiteDropdownChange);
                if (StatusDt[0].IsExceeded == "True") {
                    let ExceedData = ApprDt.filter((x) => x.IsExceeded = "True");
                    this.setState({ ExceededData: ExceedData });
                    $('#Exceeded-Popup').modal('show');
                }
                else {
                    ResponseDet.ResponseSuccessOrders = StatusDt;
                    ResponseDet.ResponseSuccessMessage = "The below order has been approved ";
                    this.setState({ ResponseDetails: ResponseDet });
                    $('#SuccessPopUp').modal('show');
                }
            }
            else {
                if (StatusDt[0].IssueType == "Data") {
                    ResponseDet.FailedDataOrders = StatusDt;
                    ResponseDet.FailedDataMessage = "Problem in approving the below order due to ";
                }
                else {
                    ResponseDet.FailedTechOrders = StatusDt;
                    ResponseDet.FailedTechMessage = "Problem in approving the below order due to ";
                }
                this.setState({ ResponseDetails: ResponseDet });
                $('#SuccessPopUp').modal('show');
            }
        }

    }
    approveDeclineResponse = () => {
        
        $(`#${SDIConstants.SDILoader}`).addClass('hide');
        let approveDeclineResponse = JSON.parse(OrderApprovalStore.approveDeclineResponse);
        if (approveDeclineResponse.length > 0) {
            let ResponseDet = {
                ResponseSuccessOrders: [],
                ResponseType: "",
                ResponseSuccessMessage: "",
                FailedTechOrders: [],
                FailedDataOrders: [],
                FailedTechMessage: "",
                FailedDataMessage: ""
            }
            if (MultipleorderApprove) {
                ResponseDet.ResponseType = "Decline";
                let SuccessOrders = approveDeclineResponse.filter((x) => x.Status == "True");
                let FailedOrders = approveDeclineResponse.filter((x) => x.Status == "False");
                if (SuccessOrders.length > 0) {
                    this.pageload(1, this.state.itemCount,
                        this.state.searchColumn, this.state.searchText, this.state.sortColumn,
                        this.state.sortValue, this.state.startDate, this.state.endDate, this.state.selectedMultiSites, this.state.isMultiSiteDropdownChange);
                    let ResponseMsg = ""
                    if (SuccessOrders.length == 1) {
                        ResponseMsg = "The below order has been declined ";
                    }
                    else {
                        ResponseMsg = "The below orders are declined ";
                    }
                    ResponseDet.ResponseSuccessOrders = SuccessOrders;
                    ResponseDet.ResponseSuccessMessage = ResponseMsg;
                }
                if (FailedOrders.length > 0) {
                    let ResponseMsg = ""
                    if (FailedOrders.length == 1) {
                        ResponseMsg = "Problem in declining the below order due to ";
                    }
                    else {
                        ResponseMsg = "Problem in declining the below orders due to ";
                    }
                    ResponseDet.FailedTechOrders = FailedOrders;
                    ResponseDet.FailedTechMessage = ResponseMsg;
                }
            }
            else {
                if (approveDeclineResponse[0].Status == "True") {
                    this.pageload(1, this.state.itemCount,
                        this.state.searchColumn, this.state.searchText, this.state.sortColumn,
                        this.state.sortValue, this.state.startDate, this.state.endDate, this.state.selectedMultiSites, this.state.isMultiSiteDropdownChange);
                    ResponseDet.ResponseSuccessOrders = approveDeclineResponse;
                    ResponseDet.ResponseSuccessMessage = "The below order has been declined ";
                }
                else {
                    ResponseDet.FailedTechOrders = approveDeclineResponse;
                    ResponseDet.FailedTechMessage = "Problem in declining the below order due to ";
                }
            }
            this.setState({ ResponseDetails: ResponseDet });
            $('#SuccessPopUp').modal('show');
        }
    }
    BuildLineResponse = () => {
        
        let approvalLineData = JSON.parse(OrderApprovalStore.LineDataResponse);
        if (approvalLineData != undefined && approvalLineData != null) {
            if (approvalLineData.OrderApprovalLineData != undefined && approvalLineData.OrderApprovalLineData != null) {
                if (approvalLineData.OrderApprovalLineData.length > 0) {
                    approvalLineData.OrderApprovalLineData.forEach((lineItem) => {
                        lineItem.extPrice = lineItem.lblConvertedExtPrice;
                        lineItem.chkDeleted = false;
                    })
                }
                this.setState({ OrderLineArray: approvalLineData.OrderApprovalLineData });
            }
        }
        if (AccordianClick == false) {
            if (this.state.MultipleLineDetails) {
                $(`#${SDIConstants.SDILoader}`).addClass('hide');
                this.approveDeclineMultipleOrder(this.state.MultipleApprDecType,true);
            }
            if (this.state.SingleLineDetails) {
                $(`#${SDIConstants.SDILoader}`).addClass('hide');
                this.approveDeclineSingleOrder(SingleaprdecDetails, SingleaprdecType, SingleaprdecIndex, SingleaprdecEvent);
            }
        }

    }
    OrderHeaderResponse = () => {
        $(`#${SDIConstants.SDILoader}`).addClass('hide');
        let approvalHeaderData = JSON.parse(OrderApprovalStore.approvalData);
        //WW-1248 Active/inactive approval flow -Vishwa S
        if (isFromEmail ) {
            if (approvalHeaderData.FlagData && approvalHeaderData.FlagData.length > 0 && approvalHeaderData.FlagData[0].isUserInActive.toLowerCase() == "true") {
                this.props.history.push({
                    pathname: "/",
                    origin: "APPROVALS",
                    phoneNo: approvalHeaderData.FlagData[0].helpDeskNo
                });
                return;
            }
        }
        if (IsBelowMyChain) {
            $(`#BelowMyChain`).addClass('active');
            $(`#MyOrders`).removeClass('active');
        }
        else {
            $(`#MyOrders`).addClass('active');
            $(`#BelowMyChain`).removeClass('active');
        }
        let localLocArray = [];
        let localDDArray = [];
        let HeaderData = [];
        let ApproverDDValue = [];
        let EnteredByDDValue = [];
        approvalHeaderData.LocationTable.map((val, index) => {
            let LocObj = {
                descr: val.DESCR,
                state: val.STATE,
                country: val.COUNTRY
            }
            let DDObj = {
                label: val.DESCR,
                value: val.STATE
            }
            localLocArray.push(LocObj)
            localDDArray.push(DDObj)
        });

        if (approvalHeaderData != undefined && approvalHeaderData != null) {
            HeaderData = approvalHeaderData.OrderApprovalData;
            if (HeaderData != undefined && HeaderData != null) {
                if (HeaderData.length > 0) {
                    HeaderData.forEach((order, index) => {
                        order.checked = false;
                        order.chkDeleted = false;
                    })
                }
            }
            if (approvalHeaderData.OrderApprover != undefined && approvalHeaderData.OrderApprover != null) {
                if (approvalHeaderData.OrderApprover.length > 0) {
                    if (approvalHeaderData.OrderApprover.length > 0) {
                        let localArray;
                        localArray = {
                            value: "",
                            label: "All Order Entered by"
                        };
                        ApproverDDValue.push(localArray)
                        approvalHeaderData.OrderApprover.map((val, index) => {
                            let localArray = {
                                value: val.CURRENT_APPR_NAME,
                                label: val.CURRENT_APPR_NAME
                            }
                            ApproverDDValue.push(localArray)

                        });
                    }
                };
            }
            if (approvalHeaderData.OrderEnteredBy != undefined && approvalHeaderData.OrderEnteredBy != null) {

                if (approvalHeaderData.OrderEnteredBy.length > 0) {
                    if (approvalHeaderData.OrderEnteredBy.length > 0) {
                        let localArray1;
                        localArray1 = {
                            value: "",
                            label: "All Pending Approver"
                        };
                        EnteredByDDValue.push(localArray1)
                        approvalHeaderData.OrderEnteredBy.map((val, index) => {
                            let localArray = {
                                value: val.ORDER_ENTERED_BY,
                                label: val.ORDER_ENTERED_BY
                            }
                            EnteredByDDValue.push(localArray)
                        });
                    }
                };
            }

            let OrderTotal;
            if (approvalHeaderData.OrderTotlaCount != undefined && approvalHeaderData.OrderTotlaCount != null) {
                OrderTotal = approvalHeaderData.OrderTotlaCount[0].TOTAL_COUNT;
            }
            if (approvalHeaderData.FlagData) {
                if (approvalHeaderData.FlagData.length > 0) {
                    flagValues = approvalHeaderData.FlagData[0];
                    flagValues["Session_UserID"] = flagValues.Session_USERID;
                    if (isFromEmail) {
                        let isTokenPresent = CookieService.getCookieValue(SDIConstants.access_token);
                        if (isTokenPresent == "") {
                            localStorage.clear();
                            CookieService.insertLocalStorageValues(flagValues);
                            console.log("InsertCookies");
                        }
                    }
                }
            }
            CookieService.updateLocalStorageValues("Session_NeedApprBUSUNIT", approvalHeaderData.FlagData.length > 0 ? approvalHeaderData.FlagData[0].Session_NeedApprBUSUNIT : "");
            this.setState({
                OrderHeaderArray: HeaderData,
                isPageLoadedOnce: true,
                totalCount: OrderTotal,
                FlagArray: approvalHeaderData.FlagData,
                pageCount: Math.ceil((OrderTotal > 0 ? OrderTotal : 0) / this.state.itemCount),
                strAppType: approvalHeaderData.FlagData.length > 0 ? approvalHeaderData.FlagData[0].strAppType : "",
                pnlBUVisible: approvalHeaderData.FlagData.length > 0 ? approvalHeaderData.FlagData[0].pnlBUVisible : false,
                ApproverNameDD: ApproverDDValue, EnteredByNameDD: EnteredByDDValue, LocationArray: localLocArray, StateDD: localDDArray, IsBelowMyChainClick: IsBelowMyChain,
                showPrice: approvalHeaderData.FlagData && approvalHeaderData.FlagData.length > 0 && approvalHeaderData.FlagData[0].ShowPrice.toUpperCase() == "TRUE" ? true : false
            });
        }

    }
    assignApprovals = () => {
        $(`#${SDIConstants.SDILoader}`).addClass('hide');
        let approvalData = JSON.parse(OrderApprovalStore.approvalData);
        console.log("approvalData", approvalData);

        //isMultipleApproval
        if (approvalData) {
            let ApproverDDValue = []
            let EnteredByDDValue = []



            let isMultipleApproval = approvalData.FlagData.length > 0 ? approvalData.FlagData[0].isMultipleApproval.toLowerCase() == "true" : false;
            if (approvalData.LineItemData.length > 0) {
                approvalData.LineItemData.forEach((lineItem) => {
                    lineItem.extPrice = lineItem.lblConvertedExtPrice;
                    lineItem.chkDeleted = false;
                });
            };
            if (approvalData.OrderApprovalData.length > 0) {
                approvalData.OrderApprovalData.forEach((order, dupindex, object) => {
                    order.checked = false;
                });

            };
            if (approvalData.OrderApprover.length > 0) {
                if (approvalData.OrderApprover.length > 0) {
                    let localArray;
                    localArray = {
                        value: "",
                        label: "All Order Entered by"
                    };
                    ApproverDDValue.push(localArray)
                    approvalData.OrderApprover.map((val, index) => {
                        let localArray = {
                            value: val.CURRENT_APPR_NAME,
                            label: val.CURRENT_APPR_NAME
                        }
                        ApproverDDValue.push(localArray)

                    });
                }
            };

            if (approvalData.OrderEnteredBy.length > 0) {
                if (approvalData.OrderEnteredBy.length > 0) {
                    let localArray1;
                    localArray1 = {
                        value: "",
                        label: "All Pending Approver"
                    };
                    EnteredByDDValue.push(localArray1)
                    approvalData.OrderEnteredBy.map((val, index) => {
                        let localArray = {
                            value: val.ORDER_ENTERED_BY,
                            label: val.ORDER_ENTERED_BY
                        }
                        EnteredByDDValue.push(localArray)
                    });
                }
            };

            console.log(approvalData.MultisiteDD);
            if (this.state.isPageLoadedOnce == false) {
                let tempMultiSites = [];

                if (approvalData.MultisiteDD) {
                    if (approvalData.MultisiteDD.length > 0) {
                        approvalData.MultisiteDD.forEach((multiSite, multiSiteindex) => {
                            tempMultiSites.push({ label: multiSite.DESCR, value: multiSite.BUSINESS_UNIT });
                        });
                    }
                }
                this.setState({ MultisiteDD: tempMultiSites })
            }
            if (approvalData.FlagData) {
                if (approvalData.FlagData.length > 0) {
                    flagValues = approvalData.FlagData[0];
                    flagValues["Session_UserID"] = flagValues.Session_USERID;
                    if (isFromEmail) {
                        let isTokenPresent = CookieService.getCookieValue(SDIConstants.access_token);
                        if (isTokenPresent == "") {
                            localStorage.clear();
                            CookieService.insertLocalStorageValues(flagValues);
                            console.log("InsertCookies");
                        }
                    }
                }
            }
            CookieService.updateLocalStorageValues("Session_NeedApprBUSUNIT", approvalData.FlagData.length > 0 ? approvalData.FlagData[0].Session_NeedApprBUSUNIT : "");
            this.setState({
                OrderApprovalData: approvalData.OrderApprovalData,
                LineItemData: approvalData.LineItemData,
                isPageLoadedOnce: true,
                totalCount: approvalData.OrderTotlaCount.length > 0 ? approvalData.OrderTotlaCount[0].TOTAL_COUNT : 0,
                pageCount: Math.ceil((approvalData.OrderTotlaCount.length > 0 ? approvalData.OrderTotlaCount[0].TOTAL_COUNT : 0) / this.state.itemCount),
                isMultipleApproval: isMultipleApproval,//isMultipleApproval,
                strAppType: approvalData.FlagData.length > 0 ? approvalData.FlagData[0].strAppType : "",
                pnlBUVisible: approvalData.FlagData.length > 0 ? approvalData.FlagData[0].pnlBUVisible : false,
                ApproverNameDD: ApproverDDValue, EnteredByNameDD: EnteredByDDValue
            });
        }
    };


    handleSearchTxt = (e) => {
        this.setState({
            isSearch: false,
            searchText: e.target.value,
        });
    }
    keyPress(e) {
        if (e.keyCode == 13) {
            this.handleSearch();
        }
    };
    handleSearch = () => {

        let pageNo = 1;
        searchTxt = this.state.searchText;
        isPostBack = false;
        this.pageload(pageNo, this.state.itemCount,
            this.state.searchColumn, searchTxt, this.state.sortColumn,
            this.state.sortValue, this.state.startDate, this.state.endDate,
            this.state.selectedMultiSites, this.state.isMultiSiteDropdownChange);

        this.setState({ pageNo: pageNo, isSearch: true, EnteredBy: "", ApproverName: "" });
    };
    ClearSearch = () => {
        this.setState({ searchText: "" });
    }
    sortingClick = (sortColumn, sortValue) => {
        console.log(sortColumn, sortValue);
        let searchColumn = this.state.searchColumn;
        if (this.state.isSearch) {
            searchTxt = $(`#searchTxt`).val().trim();
        }
        let enteredBy = this.state.EnteredBy
        let approverName = this.state.ApproverName

        if (enteredBy != "" && searchTxt == "") {
            searchColumn = "EMPNAME"
            searchTxt = enteredBy
        }
        if (approverName != "" && searchTxt == "") {
            searchColumn = "CURRENT_APPR_NAME"
            searchTxt = approverName
        }
        let pageNo = 1;
        isPostBack = false;
        this.pageload(pageNo, this.state.itemCount,
            this.state.searchColumn, searchTxt, this.state.sortColumn,
            this.state.sortValue, this.state.startDate, this.state.endDate,
            this.state.selectedMultiSites, this.state.isMultiSiteDropdownChange);
        this.setState({ pageNo: pageNo, sortColumn: sortColumn, sortValue: sortValue });
    }
    handlePageClick = (data) => {
        ;
        let pageNo = data.selected + 1;
        let searchColumn = this.state.searchColumn;
        this.setState({ pageNo: pageNo, OrderHeaderArray: [], OrderLineArray: [] });

        if (this.state.isSearch) {
            searchTxt = $(`#searchTxt`).val().trim();
        }
        let enteredBy = this.state.EnteredBy
        let approverName = this.state.ApproverName

        if (enteredBy != "" && searchTxt == "") {
            searchColumn = "EMPNAME"
            searchTxt = enteredBy
        }
        if (approverName != "" && searchTxt == "") {
            searchColumn = "CURRENT_APPR_NAME"
            searchTxt = approverName
        }
        isPostBack = false;
        let a = $('.content-row').className;
        $('.content-row').addClass('d-none');
        $('.header-arrow').removeClass('accordion-arrow-change');
        $('tr').removeClass('tr-border');
        this.setState({ isExpanded: false })
        this.pageload(pageNo, this.state.itemCount,
            searchColumn, searchTxt, this.state.sortColumn,
            this.state.sortValue, this.state.startDate, this.state.endDate, this.state.selectedMultiSites, this.state.isMultiSiteDropdownChange);
    };
    handleMultiSiteDD = (values) => {
        this.setState({ selectedMultiSites: values });
        let selectedMultiSites = [];
        values.forEach((selected) => {
            selectedMultiSites.push({ BUSINESS_UNIT: selected.value });
        });
        isPostBack = false;
        this.pageload(1,
            this.state.itemCount,
            this.state.searchColumn,
            "",
            "ORDER_NO",
            "ASC",
            "",
            "",
            selectedMultiSites,
            values.length > 0 ? true : false);
        $(`#searchTxt`).val("");
        this.setState({
            pageNo: 1,
            searchColumn: "",
            sortColumn: "ORDER_NO",
            sortValue: "ASC",
            startDate: null,
            endDate: null,
            selectedMultiSites: values,
            isMultiSiteDropdownChange: values.length > 0 ? true : false
        });
    }
    filterClick = (event, displayName, columnName) => {
        event.preventDefault();
        this.setState({ filterDisplayName: displayName, searchColumn: columnName });

    };
    BindApprovalUser = (value) => {
        let approvalstr = value.value;
        let pageNo = 1;
        searchTxt = approvalstr.trim();
        isPostBack = false;
        this.pageload(pageNo, this.state.itemCount,
            "CURRENT_APPR_NAME", searchTxt, this.state.sortColumn,
            this.state.sortValue, this.state.startDate, this.state.endDate,
            this.state.selectedMultiSites, this.state.isMultiSiteDropdownChange);
        this.setState({ ApproverName: approvalstr, pageNo: pageNo, isSearch: true, EnteredBy: "" });
    }

    BindEnteredByUser = (value) => {
        let enteredbystr = value.value;
        let pageNo = 1;
        searchTxt = enteredbystr.trim();
        isPostBack = false;
        this.pageload(pageNo, this.state.itemCount,
            "EMPNAME", searchTxt, this.state.sortColumn,
            this.state.sortValue, this.state.startDate, this.state.endDate,
            this.state.selectedMultiSites, this.state.isMultiSiteDropdownChange);
        this.setState({ EnteredBy: enteredbystr, pageNo: pageNo, isSearch: true, ApproverName: "" });
    }
    getDateString = (date) => {
        return (((date.getMonth() > 8) ? (date.getMonth() + 1) : ('0' + (date.getMonth() + 1))) + '/' + ((date.getDate() > 9) ? date.getDate() : ('0' + date.getDate())) + '/' + date.getFullYear())
    };
    handleDatePicker = (date, name) => {
        this.setState({
            [name]: date
        });
        console.log("Date", date);
    };
    applyFilterclick = () => {
        let startDate = this.state.startDateObj ? this.getDateString(this.state.startDateObj) : "";
        let endDate = this.state.endDateObj ? this.getDateString(this.state.endDateObj) : "";
        console.log(startDate, endDate);
        //[ 7/12/2022 , BUG 2320 Pavithra R]
        let months;
        months = (new Date(this.state.endDateObj).getDate() - new Date(this.state.startDateObj).getDate()) / 30 +
            new Date(this.state.endDateObj).getMonth() - new Date(this.state.startDateObj).getMonth() +
            (12 * (new Date(this.state.endDateObj).getFullYear() - new Date(this.state.startDateObj).getFullYear()));

        if (startDate != "" && endDate != "") {

            if (months <= 3) {

                if (this.state.isSearch) {
                    searchTxt = $(`#searchTxt`).val().trim();
                }
                isPostBack = false;
                this.pageload(1,
                    this.state.itemCount,
                    this.state.searchColumn,
                    searchTxt,
                    this.state.sortColumn,
                    this.state.sortValue,
                    startDate,
                    endDate,
                    this.state.selectedMultiSites,
                    this.state.isMultiSiteDropdownChange);

                this.setState({ pageNo: 1, startDate: startDate, endDate: endDate });
                this.filtertoggle();
            }
            else {
                swal({
                    allowOutsideClick: false,
                    closeOnClickOutside: false,
                    text: "Date range should be within 3 months"
                });
                // alert("Date range should be within 3 months");
                return;
            }
        }
        else {
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: "Please select From and To Date"
            })
        }
    };
    cancelFilter = () => {
        this.setState({
            startDateObj: null,
            endDateObj: null
        })
        let startDate = "";
        let endDate = "";
        console.log(startDate, endDate);


        if (this.state.isSearch) {
            searchTxt = $(`#searchTxt`).val().trim();
        }
        isPostBack = false;
        this.pageload(1,
            this.state.itemCount,
            this.state.searchColumn,
            searchTxt,
            this.state.sortColumn,
            this.state.sortValue,
            startDate,
            endDate,
            this.state.selectedMultiSites,
            this.state.isMultiSiteDropdownChange);
        this.setState({ pageNo: 1, startDate: startDate, endDate: endDate });
        this.filtertoggle();
    }
    filtertoggle = (e) => {
        if (e)
            e.preventDefault();
        this.setState({ isFilterOpen: this.state.isFilterOpen == true ? false : true });
    };
    expandAll = () => {
        if (this.state.isExpanded == false) {
            this.setState({ isExpanded: true });
            $('.header-arrow').removeClass('accordion-arrow-change');
            $('.content-row').addClass('d-none');
            $('.header-arrow').addClass('accordion-arrow-change');
            $('.content-row').removeClass('d-none');
        } else {
            this.setState({ isExpanded: false });
            $('.header-arrow').addClass('accordion-arrow-change');
            $('.content-row').removeClass('d-none');
            $('.header-arrow').removeClass('accordion-arrow-change');
            $('.content-row').addClass('d-none');

        }
    }
    onAccordianClick = (event, index, OrderNo) => {
        //$(event.currentTarget).children().toggleClass('accordion-arrow-change');
        //$(`#contentrow-${index}`).toggleClass('d-none');
        //$('tr').removeClass('tr-border');
        
        AccordianClick = true;
        let classname = document.getElementById(`contentrow-${index}`).className;
        if (classname.includes("d-none")) {
            $('.header-arrow').addClass('accordion-arrow-change');
            $('.content-row').removeClass('d-none');
            $('.header-arrow').removeClass('accordion-arrow-change');
            $('.content-row').addClass('d-none');
            //this.setState({ OrderLineArray: [] });
        }
        this.SetAccordian(event, index, OrderNo, classname);
        //$(event.currentTarget).parent('tr').addClass('tr-border');
    };
    SetAccordian = (event, index, OrderNo, classname) => {
        
        $(event.currentTarget).children().toggleClass('accordion-arrow-change');
        $(`#contentrow-${index}`).toggleClass('d-none');
        $('tr').removeClass('tr-border');
        $(event.currentTarget).parent('tr').addClass('tr-border');
        if (classname.includes("d-none")) {
            let lineDet = this.state.OrderLineArray.filter((x) => x.ORDER_NO == OrderNo);
            if (lineDet.length == 0) {
                let OrdersArray = [];
                OrdersArray.push({ OrderId: OrderNo });
                this.GetLineDetails(OrdersArray);
            }

        }
    }
    GetLineDetailsMultiple = (OrdersList, type) => {
        this.setState({ MultipleLineDetails: true, MultipleApprDecType: type, SingleLineDetails: false });
        this.GetLineDetails(OrdersList);
    }
    GetLineDetails = (OrdersList) => {
        
        let OdrNoList = OrdersList;
        let flagArray = this.state.FlagArray;
        let ApproverId = flagArray[0].Session_USERID;
        let ApproverType = flagArray[0].strAppType;
        let SessionUser = flagArray[0].Session_USERNAME;
        let SiteBU = flagArray[0].Session_SITEBU;
        let BusUnit = CookieService.getLocalStorageValues("Session_BUSUNIT") ? CookieService.getLocalStorageValues("Session_BUSUNIT") : "";
        let ThirdPartyId = CookieService.getLocalStorageValues("Session_THIRDPARTY_COMP_ID");
        let FlagArray = this.state.FlagArray;
        let isCBRE = false;
        if (ThirdPartyId == "100") {
            isCBRE = true;
        }
        let LineDataBO = {
            Order_No: OdrNoList,
            BU: BusUnit,
            Approver: ApproverId,
            Approver_Type: ApproverType,
            Session_USERNAME: SessionUser,
            Session_SITEBU: SiteBU,
            IsSourceWeb: true,
            ISCBRE: isCBRE,
            IsWeb: true,
            FlagDt: FlagArray,
            User_Type: CookieService.getLocalStorageValues("Session_USERTYPE") ? CookieService.getLocalStorageValues("Session_USERTYPE") : "",
        }
        //WW-1029 Email order approval is not working - Deepthi 
        if (isFromEmail) {
            OrderApprovalAction.getLineDataUnAuth(LineDataBO);
        }
        else {
            OrderApprovalAction.getLineData(LineDataBO);
        }

    }
    approveDeclineOrder = (orderDetails, type, SingleOrMultiple) => {
        let cookieValuesLocal = {};
        if (isFromEmail) {
            cookieValuesLocal = {
                Session_USERID: flagValues.Session_UserID ? flagValues.Session_UserID : "",
                Session_BUSUNIT: flagValues.Session_BUSUNIT ? flagValues.Session_BUSUNIT : "",
                Session_AGENTUSERID: flagValues.Session_AGENTUSERID ? flagValues.Session_AGENTUSERID : "",
                Session_AGENTUSERBU: flagValues.Session_AGENTUSERBU ? flagValues.Session_AGENTUSERBU : "",
                Session_ITEMMODE: flagValues.Session_ITEMMODE ? flagValues.Session_ITEMMODE : "",
                Session_SITEPREFIX: flagValues.Session_SITEPREFIX ? flagValues.Session_SITEPREFIX : "",
                Session_IOLServer: flagValues.Session_IOLServer ? flagValues.Session_IOLServer : "",
                Session_cplusServer: flagValues.Session_cplusServer ? flagValues.Session_cplusServer : "",
                Session_UserType: flagValues.User_Type ? flagValues.User_Type : ""
            }
        } else {
            cookieValuesLocal = {
                Session_USERID: CookieService.getLocalStorageValues("Session_UserID") ? CookieService.getLocalStorageValues("Session_UserID") : "",
                Session_BUSUNIT: CookieService.getLocalStorageValues("Session_BUSUNIT") ? CookieService.getLocalStorageValues("Session_BUSUNIT") : "",
                Session_AGENTUSERID: CookieService.getLocalStorageValues("Session_AGENTUSERID") ? CookieService.getLocalStorageValues("Session_AGENTUSERID") : "",
                Session_AGENTUSERBU: CookieService.getLocalStorageValues("Session_AGENTUSERBU") ? CookieService.getLocalStorageValues("Session_AGENTUSERBU") : "",
                Session_ITEMMODE: CookieService.getLocalStorageValues("Session_ITEMMODE") ? CookieService.getLocalStorageValues("Session_ITEMMODE") : "",
                Session_SITEPREFIX: CookieService.getLocalStorageValues("Session_SITEPREFIX") ? CookieService.getLocalStorageValues("Session_SITEPREFIX") : "",
                Session_IOLServer: CookieService.getLocalStorageValues("Session_IOLServer") ? CookieService.getLocalStorageValues("Session_IOLServer") : "",
                Session_cplusServer: CookieService.getLocalStorageValues("Session_cplusServer") ? CookieService.getLocalStorageValues("Session_cplusServer") : "",
                Session_UserType: CookieService.getLocalStorageValues("Session_USERTYPE") ? CookieService.getLocalStorageValues("Session_USERTYPE") : ""
            }
        }


        let approveDeclineBO = {
            hdnLineItem: "",
            hdnHdrItem: "AppHeaderItem",
            Session_USERID: cookieValuesLocal.Session_USERID,
            Session_BUSUNIT: cookieValuesLocal.Session_BUSUNIT,
            SESSION_SITE_CURRENCY: "",
            Session_AGENTUSERID: cookieValuesLocal.Session_AGENTUSERID,
            Session_AGENTUSERBU: cookieValuesLocal.Session_AGENTUSERBU,
            Session_ITEMMODE: cookieValuesLocal.Session_AGENTUSERBU,
            Session_SITEPREFIX: cookieValuesLocal.Session_SITEPREFIX,
            Session_IOLServer: cookieValuesLocal.Session_IOLServer,
            Session_cplusServer: cookieValuesLocal.Session_cplusServer,
            Session_OrdPlacedBy: "",
            txtTypeAppr: "W",
            OrderDetailsLst: orderDetails,
            User_Type: cookieValuesLocal.Session_UserType,
            OrderNotes: {
                ISA_LINE_STATUS: type == 1? 'QWA' : 'QWR',
                Ordernotes: this.state.comments,
                Line_NO: [0],
                UserID: cookieValuesLocal.Session_USERID,
                BU: cookieValuesLocal.Session_BUSUNIT
            }
        };
        
        let AddressDet = this.state.OrderHeaderArray.filter((x) => x.ORDER_NO == orderDetails[0].lblOrderNo);
        if (type == 1) {
            if (SingleOrMultiple == "Single") {
                if (AddressDet[0].Name == " " || AddressDet[0].Name == "" || AddressDet[0].Address == "" || AddressDet[0].Address == " " || AddressDet[0].City == "" || AddressDet[0].City == " " || AddressDet[0].State == " " || AddressDet[0].State == "" || AddressDet[0].Postal == "" || AddressDet[0].Postal == " ") {
                    swal({
                        allowOutsideClick: false,
                        closeOnClickOutside: false,
                        text: "Please enter the address details for approving the order"
                    });
                    return;
                } else {
                    $(`#${SDIConstants.SDILoader}`).removeClass('hide');
                    if (isFromEmail) {
                        OrderApprovalAction.approveHeaderOrdersUnAuth(approveDeclineBO);
                    } else {
                        OrderApprovalAction.approveHeaderOrders(approveDeclineBO);
                    }
                }
            }
            else {
                $(`#${SDIConstants.SDILoader}`).removeClass('hide');
                if (isFromEmail) {
                    OrderApprovalAction.approveHeaderOrdersUnAuth(approveDeclineBO);
                } else {
                    OrderApprovalAction.approveHeaderOrders(approveDeclineBO);
                }
            }
        }
        else {
            $(`#${SDIConstants.SDILoader}`).removeClass('hide');
            if (isFromEmail) {
                OrderApprovalAction.declineHeaderOrdersUnAuth(approveDeclineBO);
            } else {
                OrderApprovalAction.declineHeaderOrders(approveDeclineBO);
            }

        }
        $('#ApprovalComments').modal('hide');
        $('#DeclineComments').modal('hide');
        this.setState({ comments: "", inValidComments: false })
    };
    TabClick = (Type) => {
        IsBelowMyChain = (Type == "BelowMyChain") ? true : false;
        $(`#searchTxt`).val('');
        searchTxt = "";
        this.setState({ searchText: "", searchColumn: "ALL", sortColumn: "ORDER_NO", sortValue: "ASC", startDate: "", endDate: "", isSearch: false });

        //To close all the accordians when redirecting to nex tab
        $('.content-row').addClass('d-none');
        $('.header-arrow').removeClass('accordion-arrow-change');
        $('tr').removeClass('tr-border');
        let searchText = "";
        let searchColumn = "ALL"
        let sortColumn = "ORDER_NO"
        let sortValue = "ASC"
        let startDate = ""
        let endDate = ""
        let isSearch = false


        this.pageload(1, this.state.itemCount,
            searchColumn, searchText, sortColumn,
            sortValue, startDate, endDate, this.state.selectedMultiSites, this.state.isMultiSiteDropdownChange);
    }
    approveDeclineMultipleFirstClick = (type, popUp) => {

            MultipleorderApprove = true;
            AccordianClick = false;
            let orderDetails = this.state.OrderHeaderArray.filter((order) => order.checked == true);
            let allOrdersHasDetails = true;
            let OrdersArray = [];
            let allHasAddress = true;
            let addressMsg = "";
            let addressCount = 0;
            if (orderDetails.length > 0) {
                orderDetails.forEach((order, index) => {
                    if (type == 1) {
                        if (order.Name == " " || order.Name == "" || order.Address == "" || order.Address == " " || order.City == "" || order.City == " " || order.State == " " || order.State == "" || order.Postal == "" || order.Postal == " ") {
                            allHasAddress = false;
                            if (addressCount == 0) {
                                addressMsg = order.ORDER_NO;
                            }
                            else {
                                addressMsg = addressMsg + ", " + order.ORDER_NO;
                            }
                            addressCount = addressCount + 1;
                        }
                    }
                    let lineItms = this.state.OrderLineArray.filter((x) => x.ORDER_NO == order.ORDER_NO);
                    if (lineItms.length == 0) {
                        allOrdersHasDetails = false;
                        OrdersArray.push({ OrderId: order.ORDER_NO });
                    }
                    else {
                        OrdersArray.push({ OrderId: order.ORDER_NO });
                    }
                })
            }
            if (type == 1) {
                if (allHasAddress == false) {
                    if (addressCount == 0) {
                        let msg = "Please enter the address details for this Order Number " + addressMsg + " for approving the order";
                        swal({
                            allowOutsideClick: false,
                            closeOnClickOutside: false,
                            text: msg
                        });
                        return;
                    }
                    else {
                        let msg = "Please enter the address details for these Order Numbers " + addressMsg + " for approving the orders";
                        swal({
                            allowOutsideClick: false,
                            closeOnClickOutside: false,
                            text: msg
                        });
                        return;
                    }
                }
            }
            if (allOrdersHasDetails) {

                this.approveDeclineMultipleOrder(type, popUp);
            }
            else {
                $(`#${SDIConstants.SDILoader}`).removeClass('hide');
                this.GetLineDetailsMultiple(OrdersArray, type);
            }

    }
    approveDeclineMultipleOrder = (type,popUp) => {
        let orderData = [];
        let currencySymbol = "";
        let totalAmount = "";
        let orderDetails = this.state.OrderHeaderArray.filter((order) => order.checked == true);
        if (orderDetails.length > 0) {
            if (popUp) {
                if (type == 1) {
                    $('#ApprovalComments').modal('show');
                }
                else {
                    $('#DeclineComments').modal('show');
                }
                this.setState({ isMultiOrderClick: true })
            }
            else if (type == 2 && this.state.comments.length < 5) {
                this.setState({ inValidComments: true })
            }
            else {
                orderDetails.forEach((orderDetail) => {
                    let lineItms = this.state.OrderLineArray.filter((x) => x.ORDER_NO == orderDetail.ORDER_NO);

                    if (orderDetail.Ordertotal) {
                        currencySymbol = orderDetail.Ordertotal.split(" ").length > 0 ? orderDetail.Ordertotal.split(" ")[0] : "";
                        totalAmount = orderDetail.Ordertotal.split(" ").length > 0 ? orderDetail.Ordertotal.split(" ")[1] : ""
                    };
                    lineItms.map((x, index) => {
                        if (x.ORDER_NO == orderDetail.ORDER_NO && x.Add_Avail == "False" && x.VENDOR_ID == "W000000154") {
                            swal({
                                allowOutsideClick: false,
                                closeOnClickOutside: false,
                                text: "Selected order having CINTAS item without address"
                            });
                            //  alert("Selected order having CINTAS item without address")
                            return;
                        }

                    })
                    let selectedLineItms = [];
                    if (lineItms.length > 0) {
                        lineItms.forEach((lineItem, index) => {
                            selectedLineItms.push({
                                hdnLineItemValue: "",
                                hdnLineNum: lineItem.ISA_INTFC_LN,
                                txtItemChgCode: lineItem.ISA_CUST_CHARGE_CD,
                                ltrlItemNumber: lineItem.ltrlItemNumber,
                                txtQTY: lineItem.QTY_REQUESTED ? lineItem.QTY_REQUESTED : 0,
                                lblItemBasePrice: lineItem.lblBasePrice,
                                lblStockTyp: lineItem.CCINV_STOCK_TYPE ? lineItem.CCINV_STOCK_TYPE : "",
                                chkDeleted: lineItem.chkDeleted,
                                itemDescription: lineItem.DESCR254
                            });
                        });
                    };
                    let currApprId = orderDetail.CURRENT_APPR_ID;
                    orderData.push({
                        chkSelectedOrder: false,
                        lblOrderNo: orderDetail.ORDER_NO,
                        lblBuID: orderDetail.BUSINESS_UNIT,
                        lblWorkOrdNo: orderDetail.ISA_WORK_ORDER_NO,
                        lblOrderApprovalFlag11: "",
                        lblApprovalProcessFlag11: "",
                        hdnHdrAppDec: "ApproveHeaderItem",
                        lblCurrencySymbol: currencySymbol,
                        CurrentApproverID: currApprId,
                        lblAmount: totalAmount,
                        OPRID_ENTERED_BY: orderDetail.OPRID_ENTERED_BY,
                        ISA_EMPLOYEE_ID: orderDetail.ISA_EMPLOYEE_ID,
                        totalLineItems: selectedLineItms.length,
                        ChildItem: selectedLineItms
                    });
                });
                this.approveDeclineOrder(orderData, type, "Multiple");
            }
        } else {
            if (type == 1) {
                swal({
                    allowOutsideClick: false,
                    closeOnClickOutside: false,
                    text: "No Orders are selected to approve"
                });
                //  alert("No Orders are selected to approve");
            } else {
                swal({
                    allowOutsideClick: false,
                    closeOnClickOutside: false,
                    text: "No Orders are selected to decline"
                });
                //   alert("No Orders are selected to decline");
            }
        };
    };
    approveDeclineFirstClick = (orderDetails, type, index, event, popUp) => {

        if (popUp) {
            if (type == 1) {
                $('#ApprovalComments').modal('show');
            }
            else {
                $('#DeclineComments').modal('show');
            }
            this.setState({ orderDetails: orderDetails, orderIndex: index, isMultiOrderClick: false })
        }
        else if (type == 2 && this.state.comments.length < 5) {
            this.setState({ inValidComments: true })
        }
        else {

            AccordianClick = false;
            let hasLineDetails = this.state.OrderLineArray.filter((x) => x.ORDER_NO == this.state.orderDetails.ORDER_NO);
            if (hasLineDetails.length == 0) {
                let OdrNoList = [];
                OdrNoList.push({ OrderId: this.state.orderDetails.ORDER_NO });
                SingleaprdecDetails = this.state.orderDetails;
                SingleaprdecType = type
                SingleaprdecIndex = this.state.orderIndex
                SingleaprdecEvent = event;
                this.setState({ SingleLineDetails: true, MultipleLineDetails: false });
                $(`#${SDIConstants.SDILoader}`).removeClass('hide');
                this.GetLineDetails(OdrNoList);
            }
            else {

                this.approveDeclineSingleOrder(this.state.orderDetails, type, this.state.orderIndex, event);
            }
        }
    }
    approveDeclineSingleOrder = (orderDetails, type, index, event) => {
        
        MultipleorderApprove = false;
        let classname = document.getElementById(`contentrow-${index}`).className;
        if (!classname.includes("d-none")) {

            $(`#accordian-class-${index}`).toggleClass('accordion-arrow-change');
            $(`#contentrow-${index}`).toggleClass('d-none');
        }
        if (event) {
            event.preventDefault();
        }
        let orderData = [];
        let currencySymbol = "";
        let totalAmount = "";
        let lineItms = this.state.OrderLineArray.filter((x) => x.ORDER_NO == orderDetails.ORDER_NO && x.chkDeleted == false);

        if (orderDetails.Ordertotal) {
            currencySymbol = orderDetails.Ordertotal.split(" ").length > 0 ? orderDetails.Ordertotal.split(" ")[0] : "";
            totalAmount = orderDetails.Ordertotal.split(" ").length > 0 ? orderDetails.Ordertotal.split(" ")[1] : ""
        };
        let selectedLineItms = [];
        if (lineItms.length > 0) {
            lineItms.forEach((lineItem, index) => {
                selectedLineItms.push({
                    hdnLineItemValue: "",
                    hdnLineNum: lineItem.ISA_INTFC_LN,
                    txtItemChgCode: lineItem.ISA_CUST_CHARGE_CD,
                    ltrlItemNumber: lineItem.ltrlItemNumber,
                    txtQTY: lineItem.QTY_REQUESTED ? lineItem.QTY_REQUESTED : 0,
                    lblItemBasePrice: lineItem.lblBasePrice,
                    lblStockTyp: lineItem.CCINV_STOCK_TYPE ? lineItem.CCINV_STOCK_TYPE : "",
                    chkDeleted: lineItem.chkDeleted,
                    itemDescription: lineItem.DESCR254
                });
            });
        };
        let currApprId = orderDetails.CURRENT_APPR_ID;
        orderData.push({
            chkSelectedOrder: false,
            lblOrderNo: orderDetails.ORDER_NO,
            lblBuID: orderDetails.BUSINESS_UNIT,
            lblWorkOrdNo: orderDetails.ISA_WORK_ORDER_NO,
            lblOrderApprovalFlag11: "",
            lblApprovalProcessFlag11: "",
            hdnHdrAppDec: "ApproveHeaderItem",
            lblCurrencySymbol: currencySymbol,
            lblAmount: totalAmount,
            CurrentApproverID: currApprId,
            OPRID_ENTERED_BY: orderDetails.OPRID_ENTERED_BY,
            ISA_EMPLOYEE_ID: orderDetails.ISA_EMPLOYEE_ID,
            totalLineItems: selectedLineItms.length,
            ChildItem: selectedLineItms
        });
        this.approveDeclineOrder(orderData, type, "Single");


    }
    handleQuantityChange = (e, lineID, OrderNO) => {
        const re = SDIConstants.quantityRegEX;
        if (e.target.value === '' || re.test(e.target.value)) {
            if (e.target.value != "0") {
                let { LineItemData } = this.state;
                let index = LineItemData.findIndex(x => x.ORDER_NO == OrderNO && x.ISA_INTFC_LN == lineID);
                LineItemData[index].QTY_REQUESTED = e.target.value;
                if (LineItemData[index].extPrice && LineItemData[index].lblConvertedPrice && LineItemData[index].QTY_REQUESTED) {
                    LineItemData[index].extPrice = parseFloat(LineItemData[index].QTY_REQUESTED) * parseFloat(LineItemData[index].lblConvertedPrice);
                    LineItemData[index].extPrice = LineItemData[index].extPrice.toFixed(2);
                };
                this.setState(LineItemData);
            };
        };
    };
    selectOrders = (Orderindex) => {
        let { OrderHeaderArray } = this.state;

        OrderHeaderArray[Orderindex].checked = OrderHeaderArray[Orderindex].checked == true ? false : OrderHeaderArray[Orderindex].checked == false ? true : true;
        this.setState(OrderHeaderArray);
    };
    deleteItems = (value, lineID, OrderNO) => {
        
        let { OrderLineArray } = this.state;
        let indexVal = OrderLineArray.findIndex(x => x.ORDER_NO == OrderNO && x.ISA_INTFC_LN == lineID);
        OrderLineArray[indexVal].chkDeleted = value;
        let { OrderHeaderArray } = this.state;
        let headind = OrderHeaderArray.findIndex(x => x.ORDER_NO == OrderNO && x.ISA_INTFC_LN == lineID);
        OrderHeaderArray[headind].chkDeleted = value;
        this.setState({ OrderLineArray });
        this.setState({ OrderHeaderArray });
    };
    //******NEW(1/25/2021)*******************
    ItemTotalCal = (ItemPrice, Quantity) => {
        if (ItemPrice != "") {
            let ItemTotal = 0;
            //  let SiteCurrency = this.state.SiteCurrencyTable;
            let uniteprice = parseFloat(ItemPrice) ? parseFloat(ItemPrice) : 0
            let QuantityAvail = parseFloat(Quantity) ? parseFloat(Quantity) : 0
            if (uniteprice != NaN && QuantityAvail != NaN && uniteprice != 0 && QuantityAvail != 0) {
                ItemTotal = uniteprice * QuantityAvail;
                ItemTotal = ItemTotal.toFixed(2)
                //ItemTotal = uniteprice;
            }
            return ("$ " + this.formatNumber(ItemTotal))
        }
        else {
            return (ItemPrice)
        }
    }
    formatNumber = (value) => {
        if (!value) {
            return "0.00"; 
        }
        return new Intl.NumberFormat('en-US', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        }).format(value);
    }

    //*******************************
    bindApprovalLineItems = (order) => {
        let ORDER_NO = order.ORDER_NO;
        let lineItemsArray = this.state.OrderLineArray.filter((x) => x.ORDER_NO == ORDER_NO);
        let ThirdPartyID = order.THIRD_PARTY_ID;
        //let ApprovalType = ThirdPartyID != "" && ThirdPartyID != "0" && ThirdPartyID != 0 && ThirdPartyID != null ? "NTE" : "Budgetary Approval";
        return lineItemsArray.map((line, index) => {
            let addressDet = this.state.OrderHeaderArray.filter((x) => x.ORDER_NO == line.ORDER_NO);
            let LineDet;
            if (addressDet.length > 0) {
                LineDet = addressDet[0]
            }
            let Pricevalue = parseFloat(line.NET_UNIT_PRICE) ? parseFloat(line.NET_UNIT_PRICE) : 0
            let roundOffvalue = Pricevalue.toFixed(2)
            console.log("roundOffvalue", roundOffvalue);
            let PricevalueEst = parseFloat(line.extPrice) ? parseFloat(line.extPrice) : 0
            let roundOffvalueEST = PricevalueEst.toFixed(2)
            return (<div className="px-3 py-2 item-box" key={line.DESCR254}>
                <div className="row custom-bg py-3 mb-4">
                    <div className="col-md-12">
                        <div className="d-flex flex-wrap flex-lg-nowrap">
                            <div className="w-100">
                                <div className="row">
                                    <div className="col-md-12 responsive-spacing-style">
                                        <div className="w-100">
                                            <h5 className="font-16 font-bold mb-3 text-dark">{line.MFG_ITM_ID}</h5>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-12 mb-3">
                                                <label className="font-12 font-medium label-color mb-0">Description :</label>
                                                <span className="ml-2 font-12 font-regular label-value-color mb-0">{line.DESCR254}</span>
                                            </div>
                                            <div className="col-lg-3 col-md-12 mb-3">
                                                <label className="font-12 font-medium label-color mb-0">Approval type :</label>
                                                <span className="ml-2 font-12 font-regular label-value-color mb-0">{ThirdPartyID}</span>
                                            </div>
                                            <div className="col-lg-3 col-md-12 mb-3">
                                                <label className="font-12 font-medium label-color mb-0">Manufacturer :</label>
                                                <span className="ml-2 font-12 font-regular label-value-color mb-0">{line.ISA_MFG_FREEFORM}</span>
                                            </div>
                                            <div className="col-lg-3 col-md-12 mb-3">
                                                <label className="font-12 font-medium label-color mb-0">Supplier part# :</label>
                                                <span className="ml-2 font-12 font-regular label-value-color mb-0"> {line.INV_ITEM_ID != null && line.INV_ITEM_ID != undefined && line.INV_ITEM_ID != "" && line.INV_ITEM_ID != " " ? line.INV_ITEM_ID : line.ITM_ID_VNDR}</span>
                                            </div>
                                            {this.state.showPrice ? <div className="col-lg-3 col-md-12 mb-3 text-right d-none d-sm-none d-lg-block">
                                                <label className="font-12 font-medium label-color mb-0">Item base price :</label>
                                                <span className="ml-2 font-12 text-dark mb-0">{`$ ${line.lblBasePrice} ${line.lblBaseCurrCdVisible ? line.lblBaseCurrCdVisible.toLowerCase() == `true` ? line.lblBaseCurrCd : `` : ``}`}</span>
                                            </div> : null}
                                            <div className="col-lg-3 col-md-12 mb-3">
                                                <label className="font-12 font-medium label-color mb-0">Supplier :</label>
                                                <span className="ml-2 font-12 font-regular label-value-color mb-0">{line.SUPPLIERNAME}</span>
                                            </div>
                                            <div className="col-lg-3 col-md-12 mb-3">
                                                <label className="font-12 font-medium label-color mb-0">UOM :</label>
                                                <span className="ml-2 font-12 font-regular label-value-color mb-0">{line.UNIT_OF_MEASURE}</span>
                                            </div>
                                            <div className="col-lg-3 col-md-12 mb-3">
                                                <label className="font-12 font-medium label-color mb-0">Stock type :</label>
                                                <span className="ml-2 font-12 font-regular label-value-color mb-0">{line.CCINV_STOCK_TYPE != null ? line.CCINV_STOCK_TYPE : ""}</span>
                                            </div>
                                            <div className={`col-lg-3 col-md-12 mb-3 ${this.state.showPrice ? 'text-right' : ''} d-none d-sm-none d-lg-block`}>
                                                <label className="font-12 font-medium label-color mb-0">Item qty :</label>
                                                <span className="ml-2 font-12 text-dark mb-0">{`${line.QTY_REQUESTED}`}</span>
                                            </div>
                                            {this.state.showPrice ? <div className="col-md-12 text-right d-none d-sm-none d-lg-block">
                                                <label className="font-12 font-medium label-color mb-0">Ext Price :</label>
                                                <span className="ml-2 font-12 text-dark mb-0">{`${this.ItemTotalCal(roundOffvalue, line.QTY_REQUESTED)} USD`}</span>
                                            </div> : null}
                                            {this.state.showPrice ? <div className="col-lg-3 col-md-12 mb-3 text-right d-none d-lg-none d-block d-sm-block d-md-block">
                                                <label className="font-12 font-medium label-color mb-0">Item base Price :</label>
                                                <span className="ml-2 font-12 text-dark mb-0">{`$ ${line.lblBasePrice} ${line.lblBaseCurrCdVisible ? line.lblBaseCurrCdVisible.toLowerCase() == `true` ? line.lblBaseCurrCd : `` : ``}`}</span>
                                            </div> : null}
                                            <div className={`col-lg-3 col-md-12 mb-3  ${this.state.showPrice ? 'text-right' : ''} d-none d-lg-none d-block d-sm-block d-md-block`}>
                                                <label className="font-12 font-medium label-color mb-0">Item qty :</label>
                                                <span className="ml-2 font-12 text-dark mb-0">{`${line.QTY_REQUESTED}`}</span>
                                            </div>
                                            {this.state.showPrice ? <div className="col-md-12 text-right d-none d-none d-lg-none d-block d-sm-block d-md-block">
                                                <label className="font-12 font-medium label-color mb-0">Ext Price :</label>
                                                <span className="ml-2 font-12 text-dark mb-0">{`${this.ItemTotalCal(roundOffvalue, line.QTY_REQUESTED)} USD`}</span>
                                            </div> : null}

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            )
        })
    };

    bindOrderApprovals = () => {
        
        let uniqueOrders = [];
        if (this.state.OrderHeaderArray.length > 0) {
            uniqueOrders = this.state.OrderHeaderArray.filter((v, i, a) => a.findIndex(t => (t.ORDER_NO.trim().toUpperCase() === v.ORDER_NO.trim().toUpperCase())) === i);
        }
        return uniqueOrders.map((order, index) => {
            let orderindex = this.state.OrderHeaderArray.findIndex(t => (t.ORDER_NO.trim().toUpperCase() === order.ORDER_NO.trim().toUpperCase()));
            index = orderindex;
            let islineItemPresent = this.state.OrderHeaderArray.filter((x) => x.ORDER_NO == order.ORDER_NO).length > 0 ? true : false;
            console.log("bindorderdata", islineItemPresent);
            let haslineDetails = this.state.OrderLineArray.filter((x) => x.ORDER_NO == order.ORDER_NO).length > 0 ? true : false;
            let approvaladdr = this.state.OrderHeaderArray.filter((x) => x.ORDER_NO == order.ORDER_NO && x.Add_Avail != "NO" && x.chkDeleted == false).length > 0 ? true : false;
            //let addavail = this.state.LineItemData.filter((x) => x.ORDER_NO == order.ORDER_NO && ((x.Add_Avail == "False" || x.Add_Avail == false) && x.chkDeleted == false)).length > 0 ? false : true;
            // let addavail = this.state.LineItemData.filter((x) => x.ORDER_NO == order.ORDER_NO && (x.Add_Avail != "False" || x.Add_Avail != false) || (x.LINE_FIELD_C6 == "ZEUS" && x.VENDOR_ID == "W000000154" && x.chkDeleted == true)).length > 0 ? true : false;

            //let cintas = this.state.LineItemData.filter((x) => x.ORDER_NO == order.ORDER_NO && x.Add_Avail != "NO" && x.chkDeleted == false).length > 0 ? true : false;

            console.log("bindorderdata1", approvaladdr);
            return (
                <React.Fragment key={`key${index}`}>
                    <tr id={`orderApp-tr-${index}`}>
                        {isFromEmail == false && IsBelowMyChain == false ? <td className="text-center">
                            <div className="custom-control custom-checkbox item-custom-control">
                                <input type="checkbox" className="custom-control-input" checked={order.checked} id={`customCheck-approval-${index}`} name={`orderChck${index}`} onClick={(e) => this.selectOrders(index)} />
                                <label className="custom-control-label" htmlFor={`customCheck-approval-${index}`} />
                            </div>
                        </td> : null}

                        <td className="accordion-toggle" onClick={(e) => this.onAccordianClick(e, index, order.ORDER_NO)} >
                            <span id={`accordian-class-${index}`} className="accordion-arrow header-arrow" />
                        </td>
                        {/*  <td className="d-none d-sm-none d-md-table-cell">{order.DESCR}</td>*/}
                        <td>{order.ORDER_NO}</td>
                        <td className="d-none d-sm-none d-md-table-cell">{order.ISA_WORK_ORDER_NO}</td>
                        {this.state.showPrice ? <td className="d-none d-sm-none d-md-table-cell">{order.WO_TOTAL_COST}</td> : null}
                        <td className="d-none d-sm-none d-md-table-cell">{order.EMPNAME}</td>
                        <td className="d-none d-sm-none d-md-table-cell">{order.ADD_DT}</td>
                        <td className="d-none d-sm-none d-md-table-cell">{order.CURRENT_APPR_NAME}</td>
                        {this.state.showPrice ? <td className="d-none d-sm-none d-md-table-cell text-right bold-font">{order.Ordertotal}</td> : null}
                        {/*<td className="d-none d-sm-none d-md-table-cell text-right bold-font">{order.Approvaltotal}</td>*/}
                        {/*<td >{order.Comment}</td>*/}
                        {/*{IsBelowMyChain == false ? <td className="btn-column d-md-table-cell text-center d-sm-none">*/}
                        {/*    {approvaladdr ? <button className="btn custom-btn-primary" style={{ "fontSize": "11px" }} onClick={() => this.AddressCheck(order)}><Trans>Address</Trans></button> : null}*/}
                        {/*</td> : null}*/}
                        {IsBelowMyChain == false ? <td className="btn-column text-center">{/*WW-313-PC_09**/}
                            <button className="btn  grid-btn-approve mr-2 desktop-action" onClick={(e) => this.approveDeclineFirstClick(order, 1, index,e, true)}><Trans>Approve</Trans></button>
                            {/*{ShowApproveBtn  ? <button className="btn  grid-btn-approve mr-2 desktop-action" onClick={() => this.approveDeclineSingleOrder(order, 1)}><Trans>Approve</Trans></button> :
                                <button className="btn  grid-btn-approve mr-2 desktop-action custombtn-disabled" onClick={() => this.approveDeclineSingleOrder(order, 1)}><Trans>Approve</Trans></button>}*/}
                            <button className="btn  grid-btn-decline desktop-action" onClick={(e) => this.approveDeclineFirstClick(order, 2, index,e, true)}><Trans>Decline</Trans></button>
                            <a className="action-icon" onClick={(e) => this.approveDeclineFirstClick(order, 1, index,e, true)}><img className="approve-icon" src="images/approve-icon.svg" alt="approve-icon" /></a>
                            <a className="action-icon" onClick={(e) => this.approveDeclineFirstClick(order, 2, index, e, true)}><img className="reject-icon" src="images/reject-icon.svg" alt="reject-icon" /></a>
                        </td> : null}

                    </tr>
                    <tr className="p d-none content-row" id={`contentrow-${index}`}>
                        <td colSpan={12} className="hiddenRow">
                            <div className="py-3">
                                <div className="col-md-12 mx-0 mobile-fieldscontainer d-lg-none d-block item-box py-3" id="Header">
                                    <div className="row pl-5">
                                        <div className="col-12 mobile-fields p-0">
                                            <label className="catalog-label"><Trans>Business</Trans><span> </span><Trans>Unit</Trans> <span>:</span></label>
                                            <label className="item-details-value">{order.DESCR}</label>
                                        </div>
                                        <div className="col-12 mobile-fields p-0">
                                            <label className="catalog-label"><Trans>workorder_key</Trans><span> # :</span></label>
                                            <label className="item-details-value">{order.ISA_WORK_ORDER_NO}</label>
                                        </div>
                                        <div className="col-12 mobile-fields p-0">
                                            <label className="catalog-label"><Trans>orderedfor_key</Trans><span>:</span></label>
                                            <label className="item-details-value">{order.EMPNAME}</label>
                                        </div>
                                        <div className="col-12 mobile-fields p-0">
                                            <label className="catalog-label"><Trans>Created</Trans><span> </span><Trans>Date</Trans><span>:</span></label>
                                            <label className="item-details-value ">{order.ADD_DT}</label>
                                        </div>
                                        <div className="col-12 mobile-fields p-0">
                                            <label className="catalog-label"><Trans>Pending Approver</Trans><span>:</span></label>
                                            <label className="item-details-value">{order.CURRENT_APPR_NAME}</label>
                                        </div>
                                        {this.state.showPrice ? <div className="col-12 mobile-fields p-0">
                                            <label className="catalog-label"><Trans>Order</Trans><span> </span><Trans>Total</Trans><span>:</span></label>
                                            <label className="item-details-value">{order.Ordertotal}</label>
                                        </div> : null}
                                        {/*<div className="col-12 mobile-fields p-0">*/}
                                        {/*    <label className="catalog-label"><Trans>Approval</Trans><span> </span><Trans>Total</Trans><span>:</span></label>*/}
                                        {/*    <label className="item-details-value">{order.Approvaltotal}</label>*/}
                                        {/*</div>*/}
                                    </div>
                                </div>
                                {islineItemPresent ? haslineDetails ? this.bindApprovalLineItems(order) :
                                    <div style={{ "display": "flex", "justifyContent": "center" }} id="RotatingLinesId">
                                        <RotatingLines
                                            strokeColor="#fcb913"
                                            strokeWidth="5"
                                            animationDuration="0.75"
                                            width="50"
                                            visible={true} />
                                    </div>
                                    : `Line items has been approved,declined or cancelled`}
                            </div>

                        </td>
                    </tr>
                </React.Fragment>);
        });
    };
    /**
   * Listener method for the response of Save/Delete favorite page
   */
    updateFavPageResponse = () => {
        if (OrderApprovalStore.updateFavPageResponse.updateType == 1) {
            let response = JSON.parse(OrderApprovalStore.updateFavPageResponse.responseStr)[0];
            if (response.is_Success == "True") {
                $(`#${SDIConstants.SDILoader}`).addClass('hide');
                this.setState({ isFavorited: true, Page_ID: response.Page_ID });
                MenuAction.toastMessage(1);
            }
        } else {
            let response = JSON.parse(OrderApprovalStore.updateFavPageResponse.responseStr)[0];
            if (response.success == "true") {
                $(`#${SDIConstants.SDILoader}`).addClass('hide');
                this.setState({ isFavorited: false });
                MenuAction.toastMessage(2);
            }
        }
    };
    /**
    * Handle change method for favorite page checkbox
    * @param event
    */
    handleFavorite = (event) => {
        this.setState({ isFavorited: event.target.checked });
        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        if (event.target.checked == true) {
            let insertFavPageBO = {
                Session_USERID: CookieService.getLocalStorageValues("Session_UserID"),
                pageURL: currentPagePath.toLowerCase(),
                pageTitle: "Waiting Order Approval",
                Session_BUSUNIT: CookieService.getLocalStorageValues("Session_BUSUNIT")
            }
            OrderApprovalAction.insertFavPage(insertFavPageBO)
        } else {
            let deleteFavPageBO = {
                Page_ID: this.state.Page_ID
            }
            OrderApprovalAction.deleteFavPage(deleteFavPageBO)
        }
    };
    /**
    * Listener method for loading favorite page icon
    */
    loadFavPageResponse = () => {
        let favPageResponse = JSON.parse(OrderApprovalStore.currentFavPageResponse);
        if (favPageResponse.length > 0) {
            favPageResponse = favPageResponse[0];
            this.setState({ isFavorited: true, Page_ID: favPageResponse.PAGE_ID });
        };
    };

    //WW-313_PC_05 PPE Address Entry on Budgetary Approval Panel (Web Only - Cintas) -Aparna
    AddressCheck = (orderdetails) => {
        
        let approvaladdr = this.state.OrderHeaderArray.filter((x) => x.ORDER_NO == orderdetails.ORDER_NO && (x.Add_Avail == "False" || x.Add_Avail == false));
        if (approvaladdr.length > 0) {
            this.setCountry(approvaladdr[0].State)
            //WW-573 Order Approval address insertion in the pageload removal-Deepthi
            //let sta = this.state.StateDD.filter((x) => x.value == approvaladdr[0].Avail_State)
            this.setState({
                OrdNo: orderdetails.ORDER_NO, updateAddr: false, Name: approvaladdr[0].Name, Address: approvaladdr[0].Address,
                City: approvaladdr[0].City, PostCode: approvaladdr[0].Postal, State: approvaladdr[0].State, ErrName: false, ErrAddress: false, ErrCity: false, ErrPostCode: false, ErrState: false
            });//WW-313_PC_02_Default shipto -Aparna
            $('#AddressPopup').modal('show');
        }
        else {
            $('#AddressPopup').modal('show');
            let approvaladdr = this.state.OrderHeaderArray.filter((x) => x.ORDER_NO == orderdetails.ORDER_NO && (x.Add_Avail == "True" || x.Add_Avail == true));
            this.setCountry(approvaladdr[0].State)
            let sta = this.state.StateDD.filter((x) => x.value == approvaladdr[0].State)
            this.setState({
                OrdNo: orderdetails.ORDER_NO, Name: approvaladdr[0].Name, Address: approvaladdr[0].Address,
                City: approvaladdr[0].City, PostCode: approvaladdr[0].Postal, State: sta[0], updateAddr: true, ErrName: false, ErrAddress: false, ErrCity: false, ErrPostCode: false, ErrState: false
            });
        }
    }
    //
    AddressUpdate = (orderdetails) => {
        let approvaladdr = this.state.OrderHeaderArray.filter((x) => x.ORDER_NO == orderdetails.ORDER_NO && x.Add_Avail == "True");
        if (approvaladdr.length > 0) {
            $('#AddressPopup').modal('show');
            let sta = this.state.StateDD.filter((x) => x.value == approvaladdr[0].State)
            this.setState({
                OrdNo: orderdetails.ORDER_NO, Name: approvaladdr[0].Name, Address: approvaladdr[0].Address,
                City: approvaladdr[0].Name, PostCode: approvaladdr[0].Postal, State: sta, updateAddr: true
            });
        }
    }
    //WW-313_PC_10 PPE Address Entry on Budgetary Approval Panel (Web Only - Cintas) -Aparna
    onChangeAddress = (e) => {
        

        if (e.target.name == "PostCode") {
            if (e.target.value.length <= 5) {
                const re = SDIConstants.quantityRegEX;
                if ((re.test(e.target.value) && parseInt(e.target.value) > 0 || e.target.value == "")) {
                    this.setState({ PostCode: e.target.value, ErrPostCode: false })
                }
            }


        }
        else {
            let errname = this.state.ErrName;
            let erradd = this.state.ErrAddress;
            let errcity = this.state.ErrCity;
            if (e.target.name == "Name" && e.target.value.length > 0) {
                errname = false
            }
            if (e.target.name == "Address" && e.target.value.length > 0) {
                erradd = false
            }
            if (e.target.name == "City" && e.target.value.length > 0) {
                errcity = false
            }
            this.setState({ ErrName: errname, ErrAddress: erradd, ErrCity: errcity, [e.target.name]: e.target.value });
        }


    }
    onStateChange = (e, name) => {

        this.setState({ State: e, ErrState: false })
        this.setCountry(e.value)

    }

    setCountry = (state) => {
        if (state != "") {
            let matchingObject = this.state.LocationArray.find(obj => obj.state == state);
            this.setState({ CountryCode: matchingObject ? matchingObject.country : "" });
        }
        else {
            this.setState({ CountryCode: "" });
        }
    }

    errorMessage = () => {
        let ErrName = false
        let ErrAddr = false
        let ErrCity = false
        let ErrPostcode = false
        let ErrState = false
        let valid = true
        if (this.state.Name.trim() == "" || this.state.Name.trim() == " " || this.state.Name.trim() == undefined) {
            ErrName = true
            valid = false
        }
        if (this.state.Address.trim() == "" || this.state.Address.trim() == " " || this.state.Address.trim() == undefined) {
            ErrAddr = true
            valid = false
        }
        if (this.state.City.trim() == "" || this.state.City.trim() == " " || this.state.City.trim() == undefined) {
            ErrCity = true
            valid = false
        }
        if (this.state.State == "" || this.state.State == " " || this.state.State == undefined) {
            ErrState = true
            valid = false
        }
        if (this.state.PostCode.trim() == "" || this.state.PostCode.trim() == " " || this.state.PostCode.trim() == undefined) {
            ErrPostcode = true
            valid = false
        }
        this.setState({ ErrName: ErrName, ErrAddress: ErrAddr, ErrCity: ErrCity, ErrState: ErrState, ErrPostCode: ErrPostcode, valid: valid });
    }
    ExceededOkClick = () => {
        MenuAction.refreshMasterData()
        this.pageload(1, this.state.itemCount,
            this.state.searchColumn, this.state.searchText, this.state.sortColumn,
            this.state.sortValue, this.state.startDate, this.state.endDate, this.state.selectedMultiSites, this.state.isMultiSiteDropdownChange);
    }
    //WW-313_PC_06 PPE Address Entry on Budgetary Approval Panel (Web Only - Cintas) -Aparna
    AddrSaveButtonClick = (num) => {

        this.setState({ valid: false })
        this.errorMessage()

        let update = false
        if (num == 2) {
            update = true
        }
        if (this.state.valid == true) {
            let BO = {
                Orderno: this.state.OrdNo,
                Bu: CookieService.getLocalStorageValues("Session_BUSUNIT"),
                Name: this.state.Name,
                Address: this.state.Address,
                State: this.state.State.value,
                City: this.state.City,
                Postcode: this.state.PostCode,
                UpdateBool: update,
                CountryCode: this.state.CountryCode
            }
            //WW-1029 Email order approval is not working - Deepthi 
            $(`#${SDIConstants.SDILoader}`).removeClass('hide');
            if (isFromEmail) {
                OrderApprovalAction.AddrSaveButtonClickActionUnAuth(BO)
            }
            else {
                OrderApprovalAction.AddrSaveButtonClickAction(BO)
            }
        }

    }
    //WW-313_PC_08 PPE Address Entry on Budgetary Approval Panel (Web Only - Cintas) -Aparna
    AddrSaveButtonClickResponse = () => {
        
        let Response = JSON.parse(OrderApprovalStore.approvalData);
        console.log("AddrSaveButtonClickResponse", Response)
        $(`#${SDIConstants.SDILoader}`).addClass('hide');
        $('#AddressPopup').modal('hide')
        if (Response.FlagTable[0].UpdateFlg == "True") {
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: "Address details are updated succesfully!"
            });
            let { OrderHeaderArray } = this.state;
            let update = []
            update = Response.OrderApprovalData
            let approvaladdr = this.state.OrderHeaderArray.filter((x) => x.ORDER_NO == this.state.OrdNo && x.VENDOR_ID == "W000000154");// 'WW-313_PC_R2_03 remving this condition(( && x.LINE_FIELD_C6 == "ZEUS")) to display for CINTAS puchout and search item (2/9/2022) -Aparna

            OrderHeaderArray.map((x, index) => {
                //WW-313_PC_R2_03 remving this condition(( && x.LINE_FIELD_C6 == "ZEUS")) to display for CINTAS puchout and search item (2/9/2022) -Aparna
                if (x.ORDER_NO == this.state.OrdNo && x.VENDOR_ID == "W000000154") {
                    let sta = this.state.StateDD.filter((x) => x.value == update[0].STATE)
                    OrderHeaderArray[index] = { ...OrderHeaderArray[index], Add_Avail: true, Name: update[0].NAME1, Address: update[0].ADDRESS1, City: update[0].CITY, Postal: update[0].POSTAL, State: update[0].STATE };

                }

            })

            this.setState({ OrderHeaderArray });
            this.setState({
                OrdNo: "", ErrN: false,
                ErrA: false, ErrC: false, ErrS: false, ErrP: false, updateAddr: false
            })
        }
        else {
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: "Error in inserting"
            });
            // alert("Error in inserting")
            this.setState({
                OrdNo: "", ErrN: false,
                ErrA: false, ErrC: false, ErrS: false, ErrP: false, updateAddr: false
            });
        }

    }
    AddressClose = () => {
        $('#AddressPopup').modal('hide')
        this.setState({
            OrdNo: "", ErrN: false,
            ErrA: false, ErrC: false, ErrS: false, ErrP: false, updateAddr: false
        });
    }
    closeSuccessPopUp = () => {
        $('#SuccessPopUp').modal('hide');
        if (this.state.ResponseDetails.ResponseType == "Approve") {
            if (this.state.ExceededData.length > 0) {
                let ResponseDet = {
                    ResponseSuccessOrders: [],
                    ResponseType: "",
                    ResponseSuccessMessage: "",
                    FailedTechOrders: [],
                    FailedDataOrders: [],
                    FailedTechMessage: "",
                    FailedDataMessage: ""
                }
                this.setState({ ResponseDetails: ResponseDet });
                $('#Exceeded-Popup').modal('show');
            }
            else {
                if (isFromEmail) {
                    window.location.href = "/";
                }
                else {
                    MenuAction.refreshMasterData()
                    //this.pageload(1, this.state.itemCount,
                    //    this.state.searchColumn, this.state.searchText, this.state.sortColumn,
                    //    this.state.sortValue, this.state.startDate, this.state.endDate, this.state.selectedMultiSites, this.state.isMultiSiteDropdownChange);
                }
            }
        }
        else {
            if (isFromEmail) {
                window.location.href = "/";
            }
            else {
                MenuAction.refreshMasterData()
                //this.pageload(1, this.state.itemCount,
                //    this.state.searchColumn, this.state.searchText, this.state.sortColumn,
                //    this.state.sortValue, this.state.startDate, this.state.endDate, this.state.selectedMultiSites, this.state.isMultiSiteDropdownChange);
            }
        }
    }
    IncidentClick = (e, val) => {
        let customFields = [];
        customFields.push({
            customFieldName: "order_number",
            customFieldValue: val.Order_No
        })
        let PassAutheBO = {
            UserID: CookieService.getLocalStorageValues("Session_AGENTUSERID") == "" ? CookieService.getLocalStorageValues("Session_UserID") : CookieService.getLocalStorageValues("Session_AGENTUSERID"),
            UserBu: CookieService.getLocalStorageValues("Session_AGENTUSERBU") == "" ? CookieService.getLocalStorageValues("Session_BUSUNIT") : CookieService.getLocalStorageValues("Session_AGENTUSERBU"),
            EmailID: CookieService.getLocalStorageValues("Session_EMAIL"),
            IsThirdParty: CookieService.getLocalStorageValues("Session_THIRDPARTY_COMP_ID") != "0" && CookieService.getLocalStorageValues("Session_THIRDPARTY_COMP_ID") != null ? true : false,
            PassWord: "",
            OrderNumber: val.Order_No,
            PONumber: "",
            HomepageRequest: false,
            customFields: customFields,
            WorkOrder: val.WO
        }
        OrderStatusAction.getPassThroughAutheURl(PassAutheBO)
    }
    IncidentClickResponse = () => {
        let URl = JSON.parse(OrderStatusStore.PassThroughAuthe)
        window.open(URl);
        window.preventDefault();
    }
    bindSuccessOrders = () => {
        let locSuccessOrds = this.state.ResponseDetails.ResponseSuccessOrders;
        return locSuccessOrds.map((value, index) => {
            return (<li>{value.Order_No}</li>);

        });
    }
    bindFailedDataOrders = () => {
        let locFailedOrds = this.state.ResponseDetails.FailedDataOrders;
        return locFailedOrds.map((value, index) => {
            return (
                <div className="custom-conatiner-bg px-3 mb-3">
                    <div className="d-flex justify-content-between align-items-center">
                        <div>
                            <span className="font-14 font-regular text-dark">{value.Order_No}</span>
                        </div>
                        <div>
                            <a className="font-14 font-regular" onClick={(e) => this.IncidentClick(e, value)}><img className="mr-2" src="images/link-icon-new.svg" alt="link-icon" />Report incident</a>
                        </div>
                    </div>
                </div>
            );
        });
    }
    bindFailedtecOrders = () => {
        let locFailedOrds = this.state.ResponseDetails.FailedTechOrders;
        return locFailedOrds.map((value, index) => {
            return (
                <div className="custom-conatiner-bg px-3 mb-3">
                    <div className="d-flex justify-content-between align-items-center">
                        <div>
                            <span className="font-14 font-regular text-dark">{value.Order_No}</span>
                        </div>
                        <div>
                            <a className="font-14 font-regular" onClick={(e) => this.IncidentClick(e, value)}><img className="mr-2" src="images/link-icon-new.svg" alt="link-icon" />Report incident</a>
                        </div>
                    </div>
                </div>
            );
        });
    }
    bindFailedOrders = () => {
        let locFailedOrds = this.state.ResponseDetails.ResponseFailedOrders;
        return locFailedOrds.map((value, index) => {
            return (<li>{value.Order_No}</li>);
        });
    }
    bindExceededData = () => {
        return this.state.ExceededData.map((val, ind) => {
            return (<>
                <tr className="border-bottom">
                    <td>{val.Order_No}</td>
                    <td>{val.WO}</td>
                    {this.state.ExceededData.length > 0 &&
                        this.state.ExceededData[0].MessageType === "ALLINACTIVE" ? (
                            <td>{val.Approver_Mail}</td>
                        ) : (
                                <>
                                    <td>{val.Approver_Name}</td>
                                    <td>{val.Approver_Mail}</td>
                                </>
                            )
                     }
                </tr>
            </>)
        })
    }

    handleComments = (e) => {
        this.setState({ comments: e.target.value })
    }

    closeCommentsPopup = () => {
        this.setState({ comments: "", inValidComments: false })
    }

    render() {
        console.log("isFromEmail", isFromEmail);
        return (<div className="container-fluid content-section" >
            <div className="row">
                {/* Waiting Order Approval starts */}

                <div className="col-md-12 page-heading mb-3 title-margin mt-3">
                    <h5 className="page-title"><Trans>Waiting Order Approval</Trans></h5>
                    {isFromEmail == false ? <div className="fav-item-maintenance-icon ">
                        <input type="checkbox" id="checkbox-1" className="checknow" name="isFavorited" checked={this.state.isFavorited} onChange={this.handleFavorite} />
                        <label htmlFor="checkbox-1">
                            <svg className="heart-svg" viewBox="467 392 58 57" xmlns="http://www.w3.org/2000/svg">
                                <g className="Group" fill="none" fillRule="evenodd" transform="translate(467 392)">
                                    <path d="M29.144 20.773c-.063-.13-4.227-8.67-11.44-2.59C7.63 28.795 28.94 43.256 29.143 43.394c.204-.138 21.513-14.6 11.44-25.213-7.214-6.08-11.377 2.46-11.44 2.59z" className="heart" fill="#fff" />
                                    <circle className="main-circ" fill="#E2264D" opacity={0} cx="29.5" cy="29.5" r="1.5" />
                                    <g className="grp7" opacity={0} transform="translate(7 6)">
                                        <circle className="oval1" fill="#9CD8C3" cx={2} cy={6} r={2} />
                                        <circle className="oval2" fill="#8CE8C3" cx={5} cy={2} r={2} />
                                    </g>
                                    <g className="grp6" opacity={0} transform="translate(0 28)">
                                        <circle className="oval1" fill="#CC8EF5" cx={2} cy={7} r={2} />
                                        <circle className="oval2" fill="#91D2FA" cx={3} cy={2} r={2} />
                                    </g>
                                    <g className="grp3" opacity={0} transform="translate(52 28)">
                                        <circle className="oval2" fill="#9CD8C3" cx={2} cy={7} r={2} />
                                        <circle className="oval1" fill="#8CE8C3" cx={4} cy={2} r={2} />
                                    </g>
                                    <g className="grp2" opacity={0} transform="translate(44 6)">
                                        <circle className="oval2" fill="#CC8EF5" cx={5} cy={6} r={2} />
                                        <circle className="oval1" fill="#CC8EF5" cx={2} cy={2} r={2} />
                                    </g>
                                    <g className="grp5" opacity={0} transform="translate(14 50)">
                                        <circle className="oval1" fill="#91D2FA" cx={6} cy={5} r={2} />
                                        <circle className="oval2" fill="#91D2FA" cx={2} cy={2} r={2} />
                                    </g>
                                    <g className="grp4" opacity={0} transform="translate(35 50)">
                                        <circle className="oval1" fill="#F48EA7" cx={6} cy={5} r={2} />
                                        <circle className="oval2" fill="#F48EA7" cx={2} cy={2} r={2} />
                                    </g>
                                    <g className="grp1" opacity={0} transform="translate(24)">
                                        <circle className="oval1" fill="#9FC7FA" cx="2.5" cy={3} r={2} />
                                        <circle className="oval2" fill="#9FC7FA" cx="7.5" cy={2} r={2} />
                                    </g>
                                </g>
                            </svg>
                        </label>
                    </div> : null}
                    {/*  {this.state.isPageLoadedOnce && this.state.totalCount == 0 && isPostBack == true && isFromEmail == false ?null:this.state.MultisiteDD.length>0 ? <React.Fragment>
                                <label className="waiting-order-label float-left my-3">Business Unit</label>
                                <MultiSelect
                                    options={this.state.MultisiteDD}
                                    value={this.state.selectedMultiSites}
                                    onChange={this.handleMultiSiteDD}
                                    labelledBy={"Select"}
                                    className="form-control waiting-order-dropdown p-1 "
                                />
                            </React.Fragment> : null}*/}
                    {/*ADDED*/}
                    {isFromEmail == false && this.state.MultisiteDD.length > 0 ? <div id="multisitedrop">
                        <div class="col-md-4 col-lg-12 pl-0">
                            <label className="waiting-order-label float-left my-3"><Trans>Business</Trans><span> </span><Trans>Unit</Trans></label>
                        </div>
                        <div class="col-md-12 col-lg-12 pl-0">
                            <MultiSelect
                                options={this.state.MultisiteDD}
                                value={this.state.selectedMultiSites}
                                onChange={this.handleMultiSiteDD}
                                labelledBy={"Select"}
                                className="form-control waiting-order-dropdown p-1 OrderApproverMultiSite"
                            />
                        </div>
                    </div> : null}
                    {/****END********/}

                </div>
                <div class="col-md-12">
                    <ul class="nav nav-pills catalog-tabs-mobile catalog-tabs border-top-0 border-right-0 border-left-0 mt-4 mb-4" id="myTab" role="tablist">
                        <li class="nav-item mx-0">
                            <a class="nav-link active rounded-0 bg-white ml-0 my-orders pl-4" style={{ "cursor": "pointer" }} id="MyOrders" data-toggle="tab" role="tab" aria-controls="MyOrders" aria-selected="true" onClick={() => this.TabClick("MyOrders")}>My Orders</a>
                        </li>
                        {isFromEmail == false && CookieService.getLocalStorageValues("Session_USERTYPE") != "CORPADMIN" ?
                            <li class="nav-item">
                                <a class="nav-link rounded-0 bg-white below-chain pl-4" style={{ "cursor": "pointer" }} id="BelowMyChain" data-toggle="tab" role="tab" aria-controls="BelowMyChain" aria-selected="true" onClick={() => this.TabClick("BelowMyChain")}>Below My Chain</a>
                            </li> : null}
                    </ul>
                </div>
                <div className="col-md-12">
                    <div className="d-grid d-md-flex justify-content-md-end align-items-center grid-resp-style my-3">
                        {(this.state.isPageLoadedOnce && this.state.totalCount == 0 && isPostBack == true) || isFromEmail == true ? null : <> <div className="d-flex">
                            <div className="d-block mr-2 w-100">
                                <div className="input-group dropdown-search w-100">
                                    <div className="input-group-prepend">
                                        <button className="btn btn-outline-secondary dropdown-toggle font-14" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">{this.state.filterDisplayName}</button>
                                        <div className="dropdown-menu">
                                            <a className="dropdown-item" href="#" onClick={(e) => this.filterClick(e, "All", "ALL")}><Trans>All</Trans></a>
                                            {/*<a className="dropdown-item" href="#" onClick={(e) => this.filterClick(e, "Business Unit", "DESCR")}><Trans>Business</Trans><span> </span><Trans>Unit</Trans></a>*/}
                                            <a className="dropdown-item" href="#" onClick={(e) => this.filterClick(e, "Order Number", "ORDER_NO")} ><Trans>Order</Trans><span> </span><Trans>Number</Trans></a>
                                            <a className="dropdown-item" href="#" onClick={(e) => this.filterClick(e, "Work Order Number", "ISA_WORK_ORDER_NO")}><Trans>workorder_key</Trans><span> </span><Trans>Number</Trans></a>
                                            <a className="dropdown-item" href="#" onClick={(e) => this.filterClick(e, "Order Entered By", "EMPNAME")}><Trans>orderenteredby_key</Trans></a>
                                            <a className="dropdown-item" href="#" onClick={(e) => this.filterClick(e, "Pending Approver", "CURRENT_APPR_NAME")}><Trans>Pending Approver</Trans></a>
                                        </div>
                                    </div>
                                    <input type="text" className="form-control pr-5" placeholder="Search" aria-label="Text input with dropdown button" id="searchTxt" value={this.state.searchText} onKeyDown={this.keyPress} onChange={this.handleSearchTxt} />
                                    {this.state.searchText.length > 0 ? <span class="search-cancel-header cursor-pointer" style={{ "right": "25px" }} onClick={() => this.ClearSearch()} > </span> : null}
                                    <a ><span className="dropdown-search-icon" onClick={this.handleSearch} /></a>
                                </div>
                            </div>
                            <div className="d-block">
                                <span>
                                    <a className="filter-icon ml-1" title="Advance Filter" id="advanceFilterIcon" onClick={(e) => this.filtertoggle(e)}><img className="filter-icon-width" src="images/filter-icon.svg" alt="Filter Icon" /></a>
                                </span>
                                <div className={`dropdown-menu advance_filter_approval order-maintenance-filter-OA m-0 ${this.state.isFilterOpen ? 'd-block' : ''}`} id="advanced-filter" >
                                    <div className="container-fluid">
                                        <div className="row">
                                            <div className="col-md-12 p-0 pb-2 border-bottom mb-3">
                                                <span className="filter-title pl-3"><Trans>Advanced</Trans><span> </span><Trans>Filter</Trans></span>
                                                <button type="button" className="filter-close close pr-2 filter-btn" onClick={(e) => this.filtertoggle(e)}><span className="filter-close-icon" /></button>
                                            </div>
                                            <div className="col-md-12">
                                                <label className="catalog-label mb-0"><Trans>Created</Trans><span> </span><Trans>Date</Trans></label> </div>
                                            <div className="col-md-6 mb-4">
                                                <label className="catalog-label mb-0"><Trans>From</Trans></label>
                                                <DatePicker className="form-control datepicker"
                                                    id="Fromdateid"
                                                    fixedHeight
                                                    placeholderText="MM/DD/YYYY"
                                                    dateFormat="MM/dd/yyyy"
                                                    showMonthDropdown
                                                    showYearDropdown
                                                    selected={this.state.startDateObj}
                                                    maxDate={this.state.endDateObj}
                                                    onChange={(e) => this.handleDatePicker(e, "startDateObj")}

                                                />
                                                <span className="calendar-icon OA-filter-calendar-icon" onClick={() => $(`#Fromdateid`).focus()} />
                                            </div>
                                            <div className="col-md-6 mb-4">
                                                <label className="catalog-label mb-0"><Trans>To</Trans></label>
                                                <DatePicker className="form-control datepicker"
                                                    id="Todateid"
                                                    fixedHeight
                                                    placeholderText="MM/DD/YYYY"
                                                    dateFormat="MM/dd/yyyy"
                                                    showMonthDropdown
                                                    showYearDropdown
                                                    selected={this.state.endDateObj}
                                                    minDate={this.state.startDateObj}
                                                    onChange={(e) => this.handleDatePicker(e, "endDateObj")}

                                                />
                                                <span className="calendar-icon OA-filter-calendar-icon" onClick={() => $(`#Todateid`).focus()} />
                                            </div>
                                            <div className="col-md-12 mb-2">
                                                <div className="float-right">

                                                    <button className="btn btn-primary filter-clear-btn px-4 mr-2 filter-btn" onClick={this.cancelFilter} ><Trans>Clear</Trans></button>
                                                    <button className="btn btn-primary custom-btn-primary primary-btn filter-btn wallet-btn px-4" onClick={this.applyFilterclick}><Trans>Apply</Trans></button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div> </>}
                        {this.state.totalCount > 0 && isFromEmail == false && this.state.EnteredByNameDD.length > 0 ?
                            <div className="col-md-3 float-left mx-0" >
                                <span style={{ "fontSize": "13px" }}><Select
                                    id="idEnteredByDD"
                                    name="EnteredByDD"
                                    placeholder="Select Order Entered by"
                                    onChange={(e) => this.BindEnteredByUser(e)}
                                    value={this.state.EnteredBy.value}
                                    options={this.state.EnteredByNameDD}
                                /></span>
                            </div> : null}
                        {this.state.totalCount > 0 && isFromEmail == false && this.state.ApproverNameDD.length > 0 ?
                            <div className="col-md-3 float-left mx-0" >
                                <span style={{ "fontSize": "13px" }}><Select
                                    id="idApproverDD"
                                    name="ApproverDD"
                                    placeholder="Select Pending Approver"
                                    onChange={(e) => this.BindApprovalUser(e)}
                                    value={this.state.ApproverName.value}
                                    options={this.state.ApproverNameDD}
                                /></span>
                            </div> : null}
                        {this.state.totalCount > 0 && isFromEmail == false ? <div>
                            <button className="btn btn-custom-primary font-14 font-medium px-4 primary-btn-responsive" onClick={this.exportToExcel}>Export to excel</button>
                        </div> : null}
                        {this.state.totalCount > 0 && isFromEmail == false && IsBelowMyChain == false ? <div>
                            <button className="btn btn-primary custom-btn-approve primary-btn-responsive px-4" onClick={() => this.approveDeclineMultipleFirstClick(1, true)}>Approve</button>
                        </div> : null}
                        {this.state.totalCount > 0 && isFromEmail == false && IsBelowMyChain == false ? <div>
                            <button className="btn btn-primary custom-btn-decline primary-btn-responsive primary-btn px-4" onClick={() => this.approveDeclineMultipleFirstClick(2, true)}>Decline</button>
                        </div> : null}

                    </div>
                </div>
                <div className="col-lg-12">
                    <div className="table-responsive">
                        {this.state.isPageLoadedOnce && this.state.totalCount == 0 && isPostBack == true ? (<section className="site-undercontruction container text-center center-panel pt-4">
                            <div className="img-section">
                                <img src="images/nosearch.jpg" alt="imagefile" />
                            </div>
                            <p className="search-result-content pt-4"><Trans>No Records Found</Trans>
                            </p>
                        </section>) : (<table className="table ZEUS_Grid FOM-grid WOA-grid">
                            <thead>
                                <tr>
                                    {isFromEmail == false && IsBelowMyChain == false ? <th /> : null}
                                    <th />
                                    {/* <th className="d-none d-sm-none d-md-table-cell position-sort-icon"><Trans>Business</Trans><span> </span><Trans>Unit</Trans><span className="sort-up ml-1" onClick={(e) => this.sortingClick(`DESCR`, `ASC`)}><img src="Images/sort2.svg" /></span><span className="sort-down ml-1"><img src="Images/sort1.svg" onClick={(e) => this.sortingClick(`DESCR`, `DESC`)} /></span></th>*/}
                                    <th className="position-sort-icon">Order #<span className="sort-up ml-1" onClick={(e) => this.sortingClick(`ORDER_NO`, `ASC`)}><img src="Images/sort2.svg" /></span><span className="sort-down ml-1"><img src="Images/sort1.svg" onClick={(e) => this.sortingClick(`ORDER_NO`, `DESC`)} /></span></th>
                                    <th className="d-none d-sm-none d-md-table-cell position-sort-icon"><Trans>workorder_key</Trans><span> #</span><span className="sort-up ml-1" onClick={(e) => this.sortingClick(`ISA_WORK_ORDER_NO`, `ASC`)} ><img src="Images/sort2.svg" /></span><span className="sort-down ml-1"><img src="Images/sort1.svg" onClick={(e) => this.sortingClick(`ISA_WORK_ORDER_NO`, `DESC`)} /></span></th>
                                    {this.state.showPrice ? <th className="d-none d-sm-none d-md-table-cell position-sort-icon"><Trans>WO# Total cost</Trans></th> : null}
                                    <th className="d-none d-sm-none d-md-table-cell position-sort-icon"><Trans>orderenteredby_key</Trans><span className="sort-up ml-1" onClick={(e) => this.sortingClick(`EMPNAME`, `ASC`)}><img src="Images/sort2.svg" /></span><span className="sort-down ml-1"><img src="Images/sort1.svg" onClick={(e) => this.sortingClick(`EMPNAME`, `DESC`)} /></span></th>
                                    <th className="d-none d-sm-none d-md-table-cell position-sort-icon"><Trans>Created</Trans><span> </span><Trans>Date</Trans><span className="sort-up ml-1" onClick={(e) => this.sortingClick(`ADD_DT`, `ASC`)}><img src="Images/sort2.svg" /></span><span className="sort-down ml-1"><img src="Images/sort1.svg" onClick={(e) => this.sortingClick(`ADD_DT`, `DESC`)} /></span></th>
                                    <th className="d-none d-sm-none d-md-table-cell position-sort-icon"><Trans>Pending Approver</Trans><span className="sort-up ml-1" onClick={(e) => this.sortingClick(`CURRENT_APPR_NAME`, `ASC`)}><img src="Images/sort2.svg" /></span><span className="sort-down ml-1"><img src="Images/sort1.svg" onClick={(e) => this.sortingClick(`CURRENT_APPR_NAME`, `DESC`)} /></span></th>
                                    {this.state.showPrice ? <th className="d-none d-sm-none d-md-table-cell text-right position-sort-icon"><Trans>order_key</Trans><span> </span><Trans>Total</Trans><span> ($)</span></th> : null}
                                    {/*<th className="d-none d-sm-none d-md-table-cell text-right position-sort-icon"><Trans>Approval</Trans><span> </span><Trans>Total</Trans><span>($)</span></th>*/}
                                    {/*<th className="d-sm-none d-md-table-cell position-sort-icon"><Trans>Status</Trans></th>*/}
                                    {/*{IsBelowMyChain == false ? <th className="d-sm-none d-md-table-cell position-sort-icon text-center"><Trans>Address</Trans>*/}
                                    {/*    <span className="info-container ml-2">*/}
                                    {/*        <img src="Images/info-icon.png" />*/}
                                    {/*        <span className="Grid-info-icon text-left" style={{ width: "250px" }}>Address will be shown only for Cintas orders</span>*/}
                                    {/*    </span> </th> : null}*/}
                                    {IsBelowMyChain == false ? <th className="d-md-table-cell position-sort-icon text-center"><Trans>Action</Trans></th> : null}

                                </tr>
                            </thead>
                            <tbody>
                                {this.state.isPageLoadedOnce && this.state.totalCount > 0 ? this.bindOrderApprovals() :
                                    (<tr>
                                        <td colSpan="12">
                                            <section className="site-undercontruction container text-center center-panel pt-4">
                                                <div className="img-section">
                                                    <img src="images/nosearch.jpg" alt="imagefile" />
                                                </div>
                                                <p className="search-result-content pt-4"><Trans>Sorry, we couldn’t find any search result</Trans>
                                                </p>
                                            </section>
                                        </td>
                                    </tr>)}

                            </tbody>
                        </table>)}
                    </div>
                </div>
                {this.state.totalCount > 0 ? <div className="col-md-12">
                    <span className="total-records mt-2 d-inline-block">
                        <Trans>Number of Records</Trans><span>:</span><span className="ml-2">{this.state.totalCount}</span>
                    </span>
                    {this.state.totalCount > this.state.itemCount ? <ReactPaginate
                        previousLabel={<span className="right-pagination-arrow" />}
                        nextLabel={<span className="left-pagination-arrow" />}
                        previousClassName={'page-item'}
                        nextClassName={'page-item'}
                        previousLinkClassName={'page-link'}
                        nextLinkClassName={'page-link'}
                        disabledClassName={'disabled'}
                        breakLabel={'...'}
                        breakClassName={'page-item'}
                        breakLinkClassName={'page-link'}
                        pageCount={this.state.pageCount}
                        marginPagesDisplayed={1}
                        pageRangeDisplayed={2}
                        onPageChange={this.handlePageClick}
                        containerClassName={'custom-pagination pagination float-right'}
                        pageClassName={'page-item'}
                        pageLinkClassName={'page-link'}
                        activeClassName={'active'}
                        hrefBuilder={() => '#'}
                        forcePage={this.state.pageNo - 1}
                    /> : null}

                </div> : null}

            </div>
            {/**WW-313_PC_08 PPE Address Entry on Budgetary Approval Panel (Web Only - Cintas) -Aparna**/}
            <div className="modal" id="AddressPopup" data-backdrop="static" data-keyboard="false"  >
                <div className="modal-dialog modal-md custom-popup modal-dialog-centered">
                    <div className="modal-content">
                        {/*Modal Header*/}

                        <div className="modal-header">
                            <h4 className="modal-title mt-1"><Trans>Please enter your delivery address</Trans></h4>
                            <button type="button" className="btn close-btn" onClick={() => this.AddressClose()} data-dismiss="modal">
                                X
                            </button>
                        </div>
                        {/*Modal body*/}

                        <div className="modal-body">
                            <div className="row">
                                <div className="col-md-12 col-lg-12 moredetail-content">
                                    <label className="col-lg-4 col-md-12 float-left p-0 catalog-label form-label" for='Name'>Name</label>
                                    <input type="text" className="form-control" maxLength="40" name="Name" id="Name" value={this.state.Name} onChange={(e) => this.onChangeAddress(e)}></input>
                                    {this.state.ErrName ? <span className="errorspan1" style={{ fontSize: '10px', textAlign: 'left' }}><Trans>Enter</Trans><span> </span><Trans>Name</Trans></span> : null}
                                </div>
                                <div className="col-md-12 col-lg-12 moredetail-content">
                                    <label className="col-lg-4 col-md-12 float-left p-0 catalog-label form-label" for='address'>Address</label>
                                    <input type="text" className="form-control" maxLength="55" name="Address" id="address" value={this.state.Address} onChange={(e) => this.onChangeAddress(e)}></input>
                                    {this.state.ErrAddress ? <span className="errorspan1" style={{ fontSize: '10px', textAlign: 'left' }}><Trans>Enter</Trans><span> </span><Trans>Address</Trans></span> : null}
                                </div>
                                <div className="col-md-12 col-lg-12 moredetail-content">
                                    <label className="col-lg-4 col-md-12 float-left p-0 catalog-label form-label" for='city'>City</label>
                                    <input type="text" className="form-control" maxLength="30" name="City" id="city" value={this.state.City} onChange={(e) => this.onChangeAddress(e)}></input>
                                    {this.state.ErrCity ? <span className="errorspan1" style={{ fontSize: '10px', textAlign: 'left' }}><Trans>Enter</Trans><span> </span><Trans>City</Trans></span> : null}
                                </div>
                                <div className="col-md-12 col-lg-12 moredetail-content">
                                    <label className="col-lg-12 col-md-12 float-left p-0 catalog-label form-label" for='state'>State</label>
                                    <Select
                                        className="DropDown-Font-Size"
                                        options={this.state.StateDD}
                                        value={this.state.State}
                                        onChange={e => this.onStateChange(e, "State")}
                                        name="BU"
                                    />
                                    {this.state.ErrState ? <span className="errorspan1" style={{ fontSize: '10px', textAlign: 'left' }}><Trans>Enter</Trans><span> </span><Trans>State</Trans></span>

                                        : null}
                                </div>
                                <div className="col-md-12 col-lg-12 moredetail-content">
                                    <label className="col-lg-4 col-md-12 float-left p-0 catalog-label form-label" for='postcode'>Postal code</label>
                                    <input type="text" className="form-control" name="PostCode" id="postcode" maxLength={5} value={this.state.PostCode} onChange={(e) => this.onChangeAddress(e)}></input>
                                    {this.state.ErrPostCode ? <span className="errorspan1" style={{ fontSize: '10px', textAlign: 'left' }}><Trans>Enter</Trans><span> </span><Trans>Postal Code</Trans></span> : null}
                                </div>
                                <div className="col-md-12 col-lg-12 moredetail-content">
                                    <label className="col-lg-4 col-md-12 float-left p-0 catalog-label form-label" for='countryCode'>Country code</label>
                                    <input type="text" className="form-control" name="CountryCode" id="countryCode" disabled="true" value={this.state.CountryCode}></input>
                                </div>

                                {/* <div className="col-md-12 col-lg-12 moredetail-content">
                                        <label className="catalog-label d-block"><Trans>Comments</Trans></label>
                                        <textarea className="form-control custom-textarea " id="decreasoncmt" placeholder=""></textarea>
                                    </div> */}
                            </div>
                            <div className="col-md-12 mt-2 text-center p-0">


                                {this.state.updateAddr ? <button className="btn btn-primary custom-btn-primary primary-btn px-4 mt-3" id="update" onClick={() => this.AddrSaveButtonClick(2)}>Update</button> :
                                    <button className="btn btn-primary custom-btn-primary primary-btn px-4 mt-3" id="cintasbtn" onClick={() => this.AddrSaveButtonClick(1)}>Confirm</button>}
                            </div>
                        </div>

                    </div>
                </div>
            </div>
            <div className="modal fade limit-exceeded-popup p-0 show " id="Exceeded-Popup" tabIndex={-1} role="dialog" aria-modal="true" data-backdrop="static" style={{ paddingLeft: '17px' }}>
                <div className="modal-dialog modal-dialog-centered custom-bin-location-width" role="document">
                    <div className="modal-content border-0">
                        <div className="modal-header sp-delv-header align-items-center border-0">
                            <h5 className="modal-title" id="exampleModalLongTitle">Order(s) limit exceeded</h5>
                            <button type="button" className="btn-close" data-dismiss="modal" aria-label="Close"><img src="images/close-icon.svg" alt="close" onClick={(e) => this.ExceededOkClick()} /></button>
                        </div>
                        {/*Body Starts here*/}
                        <div className="modal-body py-4">
                            <div className="row">
                                <div className="col-md-12 mb-3">
                                    <span className="font-14 font-regular custom-label-color mb-1">
                                        {this.state.ExceededData.length > 0 ? (
                                            this.state.ExceededData[0].MessageType === "ACTIVE" ?
                                                (this.state.ExceededData.length > 1 ?
                                                    "These orders' limit has been exceeded and sent to next level approver." :
                                                    "This order's limit has been exceeded and sent to next level approver.") :
                                                (this.state.ExceededData[0].MessageType === "INACTIVE" ?
                                                    "The next approver is inactive and the order(s) has been sent to the alternate approver" :
                                                    (this.state.ExceededData[0].MessageType === "ALLINACTIVE" ?
                                                        "The next approver/alternate approvers are inactive and the order(s) has been notified to the below email ID" :
                                                        null
                                                    )
                                                )
                                        ) : null}
                                    </span>
                                </div>
                                {/*item details ends here*/}
                                <div className="col-md-12 mt-1">

                                    <div className="table-responsive popup-grid-scroll-style">
                                        <table className="table split-delv-table mb-0">
                                            <thead className="sticky-top">
                                                <tr>
                                                    <th>Order #</th>
                                                    <th>Work order #</th>
                                                    {this.state.ExceededData.length > 0 &&
                                                        this.state.ExceededData[0].MessageType === "ALLINACTIVE" ? (
                                                            <th>Email ID</th>
                                                        ) : (
                                                                <>
                                                                    <th>Approver name</th>
                                                                    <th>Email ID</th>
                                                                </>
                                                            )
                                                     }
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {this.bindExceededData()}
                                            </tbody>
                                        </table>
                                    </div>
                                    {/*grid ends here*/}
                                </div>
                            </div>
                        </div>
                        {/*Body ends here*/}
                        {/*button*/}
                        <div className="modal-footer border-0 d-flex justify-content-center mb-2">
                            <button className="btn btn-custom-primary font-14 font-medium px-4" data-dismiss="modal" onClick={(e) => this.ExceededOkClick()}>OK</button>
                        </div>
                        {/*button*/}
                    </div>
                </div>
            </div>

            <div className="modal fade approve-decline-status-popup p-0 show" id="SuccessPopUp" tabIndex={-1} role="dialog" aria-modal="true" style={{ paddingLeft: '17px' }} >
                <div className="modal-dialog modal-dialog-centered approve-decline-status-custom-width" role="document">
                    <div className="modal-content border-0">
                        <div className="modal-header sp-delv-header align-items-center">
                            <h5 className="modal-title" id="exampleModalLongTitle">Approve/Decline Status</h5>
                            <button type="button" className="btn-close" data-dismiss="modal" aria-label="Close" onClick={(e) => this.closeSuccessPopUp(e)}><img src="images/close-icon.svg" alt="close" /></button>
                        </div>
                        {/*Body Starts here*/}
                        <div className="modal-body popup-scroll-style">
                            <div className="row">
                                {/*Success order starts here*/}
                                {this.state.ResponseDetails.ResponseSuccessMessage != "" ? <div className="col-md-12 mb-3 mt-2">
                                    <label className="font-14 font-regular custom-label-color ">{this.state.ResponseDetails.ResponseSuccessMessage}<span className="font-medium">successfully</span></label>
                                    <ol className="pl-3">
                                        {this.bindSuccessOrders()}
                                    </ol>
                                </div> : null}
                                {/*Success order ends here*/}
                                {/*approval set up order starts here*/}
                                {this.state.ResponseDetails.FailedDataMessage != "" ? <div className="col-md-12 mb-3 mt-2">
                                    <label className="font-14 font-regular custom-label-color ">{this.state.ResponseDetails.FailedDataMessage} <span className="font-medium">approval set up</span></label>
                                    {this.bindFailedDataOrders()}
                                </div> : null}
                                {/*approval set up order ends here*/}
                                {/*approval set up order starts here*/}
                                {this.state.ResponseDetails.FailedTechMessage != "" ? <div className="col-md-12 mb-3 mt-2">
                                    <label className="font-14 font-regular custom-label-color">{this.state.ResponseDetails.FailedTechMessage}<span className="font-medium">technical issue</span></label>
                                    {this.bindFailedtecOrders()}
                                </div> : null}
                                {/*approval set up order ends here*/}
                            </div>
                        </div>
                        {/*Body ends here*/}
                        {/*button*/}
                        <div className="modal-footer border-0 pt-1 mb-2 d-flex justify-content-center">
                            <button className="btn btn-custom-primary font-14 font-medium px-4" onClick={(e) => this.closeSuccessPopUp(e)}>OK</button>
                        </div>
                        {/*button*/}
                    </div>
                </div>
            </div>

            {/*Approval comments modal starts here*/}
            <div class="modal fade approval-popup pl-0" id="ApprovalComments" tabindex="-1" role="dialog" aria-hidden="true" data-keyboard="false" data-backdrop="static">
                <div class="modal-dialog modal-dialog-centered" role="document">
                    <div class="modal-content border-0">
                        <div class="modal-header sp-delv-header align-items-center">
                            <h5 class="modal-title" >Approval comments</h5>
                            <button type="button" className="btn close-btn" data-dismiss="modal" onClick={() => this.closeCommentsPopup()} >
                                X
                            </button>
                        </div>

                        <div class="modal-body px-4">
                            <div class="row">

                                <div class="col-md-12 mb-3">
                                    <label class="form-label catalog-label" for="comments">Comments</label>
                                    <textarea class="form-control" id="ApprvComment" placeholder="Enter comments" maxLength="254" value={this.state.comments} onChange={(e) => this.handleComments(e)} rows="3"></textarea>
                                </div>

                            </div>
                        </div>

                        <div class="modal-footer border-0 pt-1 mb-2 px-4">
                            <button id="ApprvCommentCancel" class="btn btn-secondary custom-btn-secondary secondary-btn mr-2 px-4 py-2" data-dismiss="modal" onClick={() => this.closeCommentsPopup()}>Cancel</button>
                            <button id="ApprvCommentSave" class="btn btn-custom-primary font-15 font-medium px-4 py-2" onClick={(e) => this.state.isMultiOrderClick ? this.approveDeclineMultipleFirstClick(1, false) : this.approveDeclineFirstClick([], 1, "", e, false)}>Save</button>
                        </div>

                    </div>
                </div>
            </div>
            {/*Approval comments modal ends here*/}

            {/*Decline comments modal starts here*/}
            <div class="modal fade approval-popup pl-0" tabindex="-1" id="DeclineComments" role="dialog" aria-hidden="true" data-keyboard="false">
                <div class="modal-dialog modal-dialog-centered" role="document">
                    <div class="modal-content border-0">
                        <div class="modal-header sp-delv-header align-items-center">
                            <h5 class="modal-title" >Decline comments</h5>
                            <button type="button" className="btn close-btn" data-dismiss="modal" onClick={() => this.closeCommentsPopup()}>
                                X
                            </button>
                        </div>

                        <div class="modal-body px-4">
                            <div class="row">

                                <div class="col-md-12 mb-3">
                                    <label class="catalog-label" for="comments">Comments</label><span className="color-manditory" id="CmntsMandatory">*</span>
                                    <textarea class={`form-control ${this.state.inValidComments && this.state.comments.length < 5 ? 'border-color-red' : ''}`} id="DeclineComment" placeholder="Enter comments" onChange={(e) => this.handleComments(e)} maxLength="254" value={this.state.comments} rows="3"></textarea>
                                    {this.state.inValidComments && this.state.comments.length < 5 ? <label style={{ 'font-size': '15px', 'color': 'red' }} id="NotesLAbel">Please enter minimum 5 characters</label> : null}
                                </div>

                            </div>
                        </div>

                        <div class="modal-footer border-0 pt-1 mb-2 px-4">
                            <button id="DeclnCommentCancel" class="btn btn-secondary custom-btn-secondary secondary-btn mr-2 px-4 py-2" data-dismiss="modal" onClick={() => this.closeCommentsPopup()}>Cancel</button>
                            <button id="DeclnCommentSave" class="btn btn-custom-primary font-15 font-medium px-4 py-2" disabled={!this.state.comments.length} onClick={(e) => this.state.isMultiOrderClick ? this.approveDeclineMultipleFirstClick(2, false) : this.approveDeclineFirstClick([], 2, "", e, false) }>Decline</button>
                        </div>

                    </div>
                </div>
            </div>
            {/*Decline comments modal ends here*/}

        </div>);


    }
}
export default withTranslation()(OrderApprovalComponent);